import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { ReactSVG } from 'react-svg'
import Popup from 'reactjs-popup';
import { UComponent, BnSubpage } from '../Page'
import Image from '../../assets/Icons/Image.svg'
import Hashtag from '../../assets/Icons/Hashtag.svg'
import Left from '../../assets/Icons/Back.svg'
import Right from '../../assets/Icons/Forward.svg'
import CheckMark from '../../assets/Icons/Tick.svg'
import MenuUp from '../../assets/Icons/MenuUp.svg'
import Spin from '../../assets/Icons/Spin.svg'
import Down from '../../assets/Icons/Down.svg'
import Up from '../../assets/Icons/Up.svg'
import MenuDown from '../../assets/Icons/MenuDown.svg'
import Host from '../../assets/Icons/ToolServer.svg'
import ClaudePlatform from '../../assets/Icons/Platforms/Claude.svg'
import OpenAIPlatform from '../../assets/Icons/Platforms/OpenAI.svg'
import XAIPlatform from '../../assets/Icons/Platforms/xAI.svg'
import { KeyboardButton, KeyboardButton1 } from '../InputField'
import Alert from '../../assets/Icons/Alert.svg'
import { GearButton, Checkbox, SimpleButton, SimpleIcon } from './Buttons.js'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Scrollbar, Mousewheel } from 'swiper/modules';
import { isMobile, isDesktop } from '../../classes/Platform.js'
import { SearchField } from './SearchField.js'
import { getModelsDevProviderIcon } from './ModelsDevProviderIcons.js'
import usageBilling from '@attunewise/shared/usage-billing'
const moment = require('moment')
const { pickModelRouteConfig } = require('./ModelRequestConfig.js')
import './ModelsMenu.css'
import './ScrollList.css'

const providerLabelOverrides = {
  'anthropic-aws': 'Anthropic AWS',
  aws: 'Bedrock',
  azure: 'Azure',
  gcp: 'Vertex',
  qwen: 'Qwen',
  gemini: 'Gemini',
  fireworksai: 'FireworksAI',
  huggingface: 'Hugging Face',
  host: 'Local Hosts',
  'host-claude-p': 'Claude-p',
  'host-codex': 'Codex',
  'host-xai': 'Grok',
  openrouter: 'OpenRouter',
  deepinfra: 'DeepInfra',
  nebius: 'Nebius',
  'local-mlx': 'Local MLX',
  tinker: 'Tinker',
  together: 'Together',
  zerooneai: 'ZeroOneAI'
}

const providerIconAliases = {
  'anthropic-aws': 'anthropic-aws',
  aws: 'amazon',
  gcp: 'google',
  qwen: 'alibaba',
  huggingface: 'hf',
  tinker: 'thinky'
}

const inferenceBillingProviders = {
  'anthropic-aws': { id: 'amazon', name: 'Amazon', iconProviderId: 'amazon' },
  aws: { id: 'amazon', name: 'Amazon', iconProviderId: 'amazon' },
  azure: { id: 'microsoft', name: 'Microsoft', iconProviderId: 'microsoft' },
  gcp: { id: 'google', name: 'Google', iconProviderId: 'google' },
  gemini: { id: 'google', name: 'Google', iconProviderId: 'google' },
  'host-claude-p': { id: 'host', name: 'Local Hosts', iconProviderId: 'host' },
  'host-codex': { id: 'host', name: 'Local Hosts', iconProviderId: 'host' },
  'host-xai': { id: 'host', name: 'Local Hosts', iconProviderId: 'host' },
  huggingface: { id: 'huggingface', name: 'Hugging Face', iconProviderId: 'huggingface' },
  qwen: { id: 'alibaba', name: 'Alibaba', iconProviderId: 'alibaba' },
  tinker: { id: 'tinker', name: 'Tinker', iconProviderId: 'tinker' }
}

const providerIdAliases = {
  kimi: 'moonshotai'
}

const normalizeProviderId = id => {
  const normalized = String(id || '').trim().toLowerCase()
  return providerIdAliases[normalized] || normalized
}

const stableSignature = value => {
  if (value === null || value === undefined) {
    return ''
  }
  const type = typeof value
  if (type !== 'object') {
    return JSON.stringify(value)
  }
  if (Array.isArray(value)) {
    return '[' + value.map(stableSignature).join(',') + ']'
  }
  return '{' + Object.keys(value)
    .sort()
    .filter(key => typeof value[key] !== 'function')
    .map(key => JSON.stringify(key) + ':' + stableSignature(value[key]))
    .join(',') + '}'
}

const providerListSignature = vendors => (vendors || [])
  .map(vendor => [
    normalizeProviderId(vendor && vendor.id),
    vendor && vendor.name,
    vendor && vendor.disabled,
    vendor && vendor.sortOrder,
    vendor && vendor.routeClassName
  ].join(':'))
  .filter(x => x)
  .join('|')

const hostListSignature = hosts => (hosts || [])
  .map(host => [
    host && host.id,
    host && host.hostId,
    host && host.hostName,
    host && host.name,
    host && host.hostname,
    host && host.claudeCode && host.claudeCode.available
  ].join(':'))
  .sort()
  .join('|')

const oauthSignature = oauth => stableSignature({
  connected: oauth && oauth.connected,
  status: oauth && oauth.status,
  hostId: oauth && oauth.hostId,
  host: oauth && oauth.host,
  hostName: oauth && oauth.hostName,
  hostname: oauth && oauth.hostname,
  accountHost: oauth && oauth.accountHost,
  error: oauth && oauth.error
})

const titleizeProviderId = id => String(id || '')
  .split(/[-_]/)
  .filter(Boolean)
  .map(part => part.slice(0, 1).toUpperCase() + part.slice(1))
  .join(' ')

const getModelProviderId = model => {
  return normalizeProviderId(model && (model.modelProviderId || model.vendorId || model.providerId))
}

const inferenceProviderIdsCache = new WeakMap()

const getInferenceProviderIds = model => {
  if (!model) {
    return []
  }
  if (typeof model === 'object') {
    const cached = inferenceProviderIdsCache.get(model)
    if (cached &&
        cached.inferenceProviderIds === model.inferenceProviderIds &&
        cached.inferenceProviders === model.inferenceProviders &&
        cached.inferenceProviderId === model.inferenceProviderId) {
      return cached.value
    }
  }
  let value
  if (Array.isArray(model.inferenceProviderIds) && model.inferenceProviderIds.length) {
    value = model.inferenceProviderIds.map(normalizeProviderId).filter(x => x)
  } else if (Array.isArray(model.inferenceProviders) && model.inferenceProviders.length) {
    value = model.inferenceProviders.map(provider => normalizeProviderId(provider && (provider.id || provider.providerId))).filter(x => x)
  } else if (model.inferenceProviderId) {
    value = [normalizeProviderId(model.inferenceProviderId)]
  } else {
    value = []
  }
  if (typeof model === 'object') {
    inferenceProviderIdsCache.set(model, {
      inferenceProviderIds: model.inferenceProviderIds,
      inferenceProviders: model.inferenceProviders,
      inferenceProviderId: model.inferenceProviderId,
      value
    })
  }
  return value
}

const providerNamesCache = new WeakMap()

const providerNamesById = providers => {
  if (providers && typeof providers === 'object') {
    const cached = providerNamesCache.get(providers)
    if (cached) {
      return cached
    }
  }
  const names = {}
  for (const provider of providers || []) {
    if (provider && provider.id) {
      names[normalizeProviderId(provider.id)] = provider.name
    }
  }
  if (providers && typeof providers === 'object') {
    providerNamesCache.set(providers, names)
  }
  return names
}

const providerNodesCache = new WeakMap()

const providerNodesById = providers => {
  if (providers && typeof providers === 'object') {
    const cached = providerNodesCache.get(providers)
    if (cached) {
      return cached
    }
  }
  const nodes = {}
  for (const provider of providers || []) {
    const id = normalizeProviderId(provider && (provider.id || provider.providerId))
    if (id) {
      nodes[id] = provider
    }
  }
  if (providers && typeof providers === 'object') {
    providerNodesCache.set(providers, nodes)
  }
  return nodes
}

const runtimeConfigForProvider = (model, providerId) => {
  providerId = normalizeProviderId(providerId)
  if (!model || !providerId) {
    return null
  }
  const provider = providerNodesById(model.inferenceProviders)[providerId]
  if (!provider) {
    return null
  }
  const fields = [
    'runtimeModelId',
    'compatibility',
    'apiBase',
    'modelsDevProviderId',
    'supportedReasoningEfforts',
    'defaultReasoningEffort',
    'supportedPricingModes',
    'defaultPricingMode',
    'supportedVerbosityLevels',
    'defaultVerbosityLevel',
    'displayPriceLabel',
    'billingModelId',
    'hostLabel',
    'virtualInferenceProvider',
    'desktopHostId',
    'promptTemplate'
  ]
  const actualInferenceProviderId = provider.actualInferenceProviderId || providerId
  const config = {
    inferenceProviderId: provider.virtualInferenceProvider ? providerId : actualInferenceProviderId,
    actualInferenceProviderId,
    displayInferenceProviderId: providerId,
    displayInferenceProviderName: provider.name,
    inferenceProvider: provider.name
  }
  if (provider.virtualInferenceProvider) {
    config.routeInferenceProviderId = providerId
  }
  fields.forEach(field => {
    if (provider[field] !== undefined) {
      config[field === 'compatibility' ? 'providerCompatibility' : field] = provider[field]
    }
  })
  if (!config.billingModelId && model.id) {
    config.billingModelId = usageBilling.billingModelId(providerId, model.id)
  }
  return config
}

const runtimeSelectionProviderId = config => normalizeProviderId(config && (
  config.displayInferenceProviderId ||
  config.routeInferenceProviderId ||
  config.inferenceProviderId
))

const formatPricePair = (price, format) => {
  if (!price) {
    return ''
  }
  const { input, output } = price
  if (!input && !output) {
    return ''
  }
  if (input === output) {
    return '$' + format(input)
  }
  return '$' + format(input) + '/' + format(output)
}

const isCustomModel = model => {
  return getModelProviderId(model) === 'custom' || model && model.providerId === 'custom'
}

const getProviderName = (id, vendors, names = {}) => {
  id = normalizeProviderId(id)
  if (providerLabelOverrides[id]) {
    return providerLabelOverrides[id]
  }
  if (names[id]) {
    return names[id]
  }
  const vendor = (vendors || []).find(vendor => normalizeProviderId(vendor.id) === id)
  if (vendor) {
    return vendor.name
  }
  return titleizeProviderId(id)
}

const getProviderIconVendor = (id, vendors) => {
  id = normalizeProviderId(id)
  const virtualProvider = getVirtualInferenceProvider(id)
  if (virtualProvider) {
    return {
      id,
      sortOrder: virtualProvider.sortOrder !== undefined ? virtualProvider.sortOrder : 0,
      getIcon: () => virtualProvider.icon
    }
  }
  if (id === 'host') {
    return {
      id,
      sortOrder: 0,
      getIcon: () => Host
    }
  }
  const alias = providerIconAliases[id]
  const vendor = (vendors || []).find(vendor => normalizeProviderId(vendor.id) === id) ||
    (vendors || []).find(vendor => normalizeProviderId(vendor.id) === alias)
  if (vendor) {
    return vendor
  }
  const icon = getModelsDevProviderIcon(id) || getModelsDevProviderIcon(alias)
  if (!icon) {
    return null
  }
  return {
    id,
    sortOrder: 1000,
    getIcon: () => icon
  }
}

const createProviderOption = (id, vendors, names = {}) => {
  id = normalizeProviderId(id)
  const iconVendor = getProviderIconVendor(id, vendors)
  const iconVendorId = iconVendor && normalizeProviderId(iconVendor.id)
  if (!iconVendorId) {
    return null
  }
  const name = getProviderName(id, vendors, names)
  return {
    id,
    name,
    iconVendorId,
    usesIconAlias: !!(iconVendorId && iconVendorId !== id),
    routeClassName: getProviderRouteClassName(id),
    sortOrder: iconVendor && iconVendor.sortOrder !== undefined ? iconVendor.sortOrder : 1000,
    getIcon: () => iconVendor && iconVendor.getIcon ? iconVendor.getIcon() : null
  }
}

const createModelBackedProviderOption = (id, model, vendors, names = {}) => {
  const option = createProviderOption(id, vendors, names)
  if (option) {
    return option
  }
  const icon = model && model.getIcon ? model.getIcon() : null
  if (!icon) {
    return null
  }
  return {
    id: normalizeProviderId(id),
    name: getProviderName(id, vendors, names),
    iconVendorId: null,
    usesIconAlias: false,
    routeClassName: getProviderRouteClassName(id),
    sortOrder: model && model.sortOrder !== undefined ? model.sortOrder : 1000,
    getIcon: () => icon
  }
}

const routeClassNameForProviderIds = providerIds => {
  const classes = new Set((providerIds || []).map(getProviderRouteClassName).filter(x => x))
  if (!classes.size) {
    return ''
  }
  if (classes.size > 1) {
    return subscriptionRouteClasses.mixed
  }
  return Array.from(classes)[0]
}

const sortOrderForProviderIds = providerIds => {
  const orders = (providerIds || []).map(getProviderSortOrder).filter(value => value !== null)
  if (!orders.length) {
    return null
  }
  return Math.min(...orders)
}

const createInferenceBillingProviderOption = (id, providerIds, vendors, names = {}) => {
  id = normalizeProviderId(id)
  providerIds = providerIds.map(normalizeProviderId).filter(x => x)
  const billingProvider = inferenceBillingProviders[id] || {}
  const groupId = normalizeProviderId(billingProvider.id || id)
  const iconProviderId = normalizeProviderId(billingProvider.iconProviderId || groupId)
  const iconVendor = getProviderIconVendor(iconProviderId, vendors)
  const iconVendorId = iconVendor && normalizeProviderId(iconVendor.id)
  if (!iconVendorId) {
    return null
  }
  return {
    id: groupId,
    providerIds,
    name: billingProvider.name || getProviderName(groupId, vendors, names),
    iconVendorId,
    usesIconAlias: !!(iconVendorId && iconVendorId !== groupId),
    routeClassName: routeClassNameForProviderIds(providerIds),
    sortOrder: sortOrderForProviderIds(providerIds) ??
      (iconVendor && iconVendor.sortOrder !== undefined ? iconVendor.sortOrder : 1000),
    getIcon: () => iconVendor && iconVendor.getIcon ? iconVendor.getIcon() : null
  }
}

const getProviderNameList = (ids, vendors, names = {}) => ids.map(id => getProviderName(id, vendors, names))

const getSelectedProviderCount = selected => Object.keys(selected || {}).filter(id => selected[id]).length

const selectedProviderMap = (selected, providers) => {
  const validProviderIds = new Set()
  for (const provider of providers || []) {
    const id = normalizeProviderId(provider && provider.id)
    if (id) {
      validProviderIds.add(id)
    }
    for (const providerId of provider && provider.providerIds || []) {
      validProviderIds.add(normalizeProviderId(providerId))
    }
  }
  const result = {}
  for (const id in selected || {}) {
    const normalized = normalizeProviderId(id)
    if (selected[id] && (!validProviderIds.size || validProviderIds.has(normalized))) {
      result[normalized] = true
      const provider = (providers || []).find(provider => {
        if (normalizeProviderId(provider && provider.id) === normalized) {
          return true
        }
        return (provider && provider.providerIds || []).map(normalizeProviderId).includes(normalized)
      })
      for (const providerId of provider && provider.providerIds || []) {
        result[normalizeProviderId(providerId)] = true
      }
    }
  }
  return result
}

const providerIntersectsSelection = (ids, selected, customProviderSelected) => {
  selected = selected || {}
  return (ids || []).find(id => selected[normalizeProviderId(id)]) || customProviderSelected && selected.custom
}

const CODEX_BACKED_OPENAI_MODELS = new Set([
  'gpt-5.4',
  'gpt-5.4-mini',
  'gpt-5.5',
  'gpt-5.5-mini',
  'gpt-5.6',
  'gpt-5.6-sol',
  'gpt-5.6-terra',
  'gpt-5.6-luna',
  'gpt-5-codex'
])

const subscriptionRouteClasses = {
  codex: 'modelSubscriptionRoute modelSubscriptionRouteCodex',
  claude: 'modelSubscriptionRoute modelSubscriptionRouteClaude',
  mixed: 'modelSubscriptionRoute modelSubscriptionRouteMixed'
}

const virtualInferenceProviders = {
  'host-codex': {
    id: 'host-codex',
    name: 'Codex',
    actualInferenceProviderId: 'openai',
    icon: OpenAIPlatform,
    sortOrder: -200,
    routeId: 'codex',
    routeClassName: subscriptionRouteClasses.codex
  },
  'host-claude-p': {
    id: 'host-claude-p',
    name: 'Claude-p',
    actualInferenceProviderId: 'anthropic',
    icon: ClaudePlatform,
    sortOrder: -199,
    routeId: 'claude-p',
    routeClassName: subscriptionRouteClasses.claude
  },
  'host-xai': {
    id: 'host-xai',
    name: 'xAI',
    actualInferenceProviderId: 'xai',
    icon: XAIPlatform,
    sortOrder: -198,
    routeId: 'xai',
    routeClassName: subscriptionRouteClasses.mixed
  }
}

const getVirtualInferenceProvider = id => virtualInferenceProviders[normalizeProviderId(id)]

const getActualInferenceProviderId = id => {
  const virtualProvider = getVirtualInferenceProvider(id)
  return virtualProvider && virtualProvider.actualInferenceProviderId || normalizeProviderId(id)
}

const getProviderRouteClassName = id => {
  const virtualProvider = getVirtualInferenceProvider(id)
  return virtualProvider && virtualProvider.routeClassName || ''
}

const getProviderSortOrder = id => {
  const virtualProvider = getVirtualInferenceProvider(id)
  return virtualProvider && virtualProvider.sortOrder !== undefined ? virtualProvider.sortOrder : null
}

const parseOpenAIBaseModelId = value => {
  let modelId = String(value || '').trim().toLowerCase()
  if (!modelId) {
    return ''
  }
  modelId = modelId
    .replace(/^openai[/:._-]/, '')
    .replace(/^models[/:._-]/, '')
  if (modelId.endsWith('-flex')) {
    modelId = modelId.slice(0, -'-flex'.length)
  }
  for (const suffix of ['-xhigh', '-medium', '-high', '-low', '-none']) {
    if (modelId.endsWith(suffix)) {
      return modelId.slice(0, -suffix.length)
    }
  }
  return modelId
}

const modelIdCandidates = model => {
  const values = [
    model && model.runtimeModelId,
    model && model.modelsDevId,
    model && model.rootModel,
    model && model.modelId,
    model && model.id
  ]
  const seen = {}
  const result = []
  for (const value of values) {
    const parsed = parseOpenAIBaseModelId(value)
    if (parsed && !seen[parsed]) {
      seen[parsed] = true
      result.push(parsed)
    }
  }
  return result
}

const providerNodeForId = (model, providerId) => {
  providerId = normalizeProviderId(providerId)
  return providerNodesById(model && model.inferenceProviders)[providerId]
}

const getHostLabel = host => {
  return host && (host.hostName || host.name || host.hostname || host.hostId || host.id)
}

const getAvailableClaudeCodeHost = (hosts, me) => {
  for (const host of hosts || []) {
    if (!host || !host.claudeCode || !host.claudeCode.available) {
      continue
    }
    if (me && me.isHostDisabled && me.isHostDisabled(host)) {
      continue
    }
    return host
  }
  return null
}

const getEnabledHost = (hosts, me) => {
  return (hosts || [])
    .filter(host => host && !(me && me.isHostDisabled && me.isHostDisabled(host)))
    .slice()
    .sort((left, right) => {
      const leftSeen = Number(left.lastSeen || left.lastUpdated || 0)
      const rightSeen = Number(right.lastSeen || right.lastUpdated || 0)
      return rightSeen - leftSeen
    })[0] || null
}

const getCodexHostId = opts => {
  const oauth = opts && opts.openAICodexOAuth || {}
  return oauth.hostId || oauth.host || oauth.accountHost || oauth.hostname || oauth.hostName || null
}

const getCodexHost = opts => {
  const hostId = String(getCodexHostId(opts) || '').trim()
  const hosts = opts && opts.hosts || []
  if (hostId) {
    const matched = hosts.find(host => {
      return [host && host.id, host && host.hostId, host && host.hostName, host && host.name, host && host.hostname]
        .filter(Boolean)
        .map(String)
        .includes(hostId)
    })
    if (matched && !(opts.me && opts.me.isHostDisabled && opts.me.isHostDisabled(matched))) {
      return matched
    }
  }
  return getEnabledHost(hosts, opts && opts.me)
}

const getCodexHostLabel = opts => {
  return getHostLabel(getCodexHost(opts)) ||
    getCodexHostId(opts) ||
    'Host'
}

const modelCanUseCodexHost = (model, opts = {}) => {
  const inferenceProviderIds = getInferenceProviderIds(model)
  return getModelProviderId(model) === 'openai' &&
    inferenceProviderIds.includes('openai') &&
    opts.openAICodexOAuth &&
    opts.openAICodexOAuth.connected &&
    getCodexHost(opts) &&
    modelIdCandidates(model).find(id => CODEX_BACKED_OPENAI_MODELS.has(id))
}

const modelCanUseClaudePHost = (model, opts = {}) => {
  const inferenceProviderIds = getInferenceProviderIds(model)
  return getModelProviderId(model) === 'anthropic' &&
    inferenceProviderIds.includes('anthropic') &&
    getAvailableClaudeCodeHost(opts.hosts, opts.me)
}

const getXaiHost = (opts = {}) => {
  const hosts = opts.hosts || []
  return hosts.find(host => (
    host && host.xai && host.xai.connected &&
    !(opts.me && opts.me.isHostDisabled && opts.me.isHostDisabled(host))
  ))
}

const modelCanUseXaiHost = (model, opts = {}) => {
  const inferenceProviderIds = getInferenceProviderIds(model)
  return getModelProviderId(model) === 'xai' &&
    inferenceProviderIds.includes('xai') &&
    getXaiHost(opts)
}

const virtualInferenceProvidersForModel = (model, opts = {}) => {
  const result = []
  if (modelCanUseCodexHost(model, opts)) {
    result.push(virtualInferenceProviders['host-codex'])
  }
  if (modelCanUseClaudePHost(model, opts)) {
    result.push(virtualInferenceProviders['host-claude-p'])
  }
  if (modelCanUseXaiHost(model, opts)) {
    result.push(virtualInferenceProviders['host-xai'])
  }
  return result
}

const virtualProviderHostLabel = (virtualProvider, opts = {}) => {
  if (virtualProvider.id === 'host-claude-p') {
    return getHostLabel(getAvailableClaudeCodeHost(opts.hosts, opts.me)) || 'Host'
  }
  if (virtualProvider.id === 'host-codex') {
    return getCodexHostLabel(opts)
  }
  if (virtualProvider.id === 'host-xai') {
    return getHostLabel(getXaiHost(opts)) || 'Host'
  }
  return 'Host'
}

const virtualProviderBillingModelId = (model, virtualProvider) => {
  const routeId = virtualProvider && virtualProvider.id
  const modelId = model && model.id
  return usageBilling.billingModelId(routeId, modelId)
}

const virtualProviderNodeForModel = (model, virtualProvider, opts = {}) => {
  const actualNode = providerNodeForId(model, virtualProvider.actualInferenceProviderId) || {}
  const host = virtualProvider.id === 'host-claude-p'
    ? getAvailableClaudeCodeHost(opts.hosts, opts.me)
    : virtualProvider.id === 'host-xai'
      ? getXaiHost(opts)
      : getCodexHost(opts)
  const hostLabel = virtualProviderHostLabel(virtualProvider, opts)
  return {
    ...actualNode,
    id: virtualProvider.id,
    providerId: virtualProvider.id,
    name: virtualProvider.name,
    actualInferenceProviderId: virtualProvider.actualInferenceProviderId,
    virtualInferenceProvider: true,
    hostLabel,
    desktopHostId: host && (host.hostId || host.id) || (virtualProvider.id === 'host-codex' ? getCodexHostId(opts) : undefined),
    displayPriceLabel: hostLabel,
    billingModelId: virtualProviderBillingModelId(model, virtualProvider),
    sortOrder: virtualProvider.sortOrder,
    runtimeModelId: actualNode.runtimeModelId || model.runtimeModelId,
    compatibility: actualNode.compatibility || model.providerCompatibility,
    apiBase: actualNode.apiBase || model.apiBase,
    modelsDevProviderId: actualNode.modelsDevProviderId || model.modelsDevProviderId,
    promptTemplate: actualNode.promptTemplate || model.promptTemplate,
    contexts: actualNode.contexts || model.contexts
  }
}

const withVirtualInferenceProviders = (model, opts = {}) => {
  if (!model) {
    return model
  }
  const virtualProviders = virtualInferenceProvidersForModel(model, opts)
  if (!virtualProviders.length) {
    return model
  }
  const inferenceProviderIds = getInferenceProviderIds(model)
  const existing = new Set(inferenceProviderIds)
  const inferenceProviders = Array.isArray(model.inferenceProviders)
    ? model.inferenceProviders.slice()
    : inferenceProviderIds.map(id => ({ id, name: getProviderName(id, opts.vendors || []) }))
  for (const virtualProvider of virtualProviders) {
    if (existing.has(virtualProvider.id)) {
      continue
    }
    existing.add(virtualProvider.id)
    inferenceProviderIds.unshift(virtualProvider.id)
    inferenceProviders.unshift(virtualProviderNodeForModel(model, virtualProvider, opts))
  }
  return {
    ...model,
    inferenceProviderIds,
    inferenceProviders
  }
}

const resolveSelectedInferenceProviderId = (model, providerId) => {
  const explicitProviderId = normalizeProviderId(providerId)
  if (explicitProviderId) {
    return explicitProviderId
  }
  const displayProviderId = normalizeProviderId(model && model.displayInferenceProviderId)
  if (displayProviderId) {
    return displayProviderId
  }
  const routeProviderId = normalizeProviderId(model && model.routeInferenceProviderId)
  if (routeProviderId) {
    return routeProviderId
  }
  const modelProviderId = normalizeProviderId(model && model.inferenceProviderId)
  if (modelProviderId) {
    return modelProviderId
  }
  const inferenceProviderIds = getInferenceProviderIds(model)
  return inferenceProviderIds.length === 1 ? inferenceProviderIds[0] : ''
}

const hasAvailableClaudeCodeHost = (hosts, me) => {
  return !!getAvailableClaudeCodeHost(hosts, me)
}

export const getSubscriptionRouteIndicator = (model, providerId, opts = {}) => {
  const displayProviderId = normalizeProviderId(providerId || model && model.displayInferenceProviderId)
  if (displayProviderId === 'host-codex' && modelCanUseCodexHost(model, opts)) {
    return {
      id: 'codex',
      name: 'Codex',
      className: subscriptionRouteClasses.codex
    }
  }
  if (displayProviderId === 'host-claude-p' && modelCanUseClaudePHost(model, opts)) {
    return {
      id: 'claude-p',
      name: 'Claude-p',
      className: subscriptionRouteClasses.claude
    }
  }
  if (displayProviderId === 'host-xai' && modelCanUseXaiHost(model, opts)) {
    return {
      id: 'xai',
      name: 'Grok',
      className: subscriptionRouteClasses.mixed
    }
  }
  return null
}

class VendorItems extends Component {

  constructor(props) {
    super(props)
    this.state = {mounted: false}
  }

  componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  componentWillUnmount() {
  }
  
  render() {
    let style
    if (this.state.mounted) {
      style = {
        opacity: 1
      }
    }
    return <div className='desktopVendorItemsDiv' style={style}>
      {this.props.children}
    </div>
  }
}

export class PopupSelectionList extends Component {
  render() {
    return <div className='popupSelectionList'>
             <div className='popupSelectionListTitle'>
               {this.props.title}
             </div>
             <div className='popupSelectionListSelection'>
               <select>
                 {
                   this.props.options.map(option => {
                     return <option key={option.key} value={option.value}>
                              {option.label}
                            </option>
                   })
                 }
               </select>
             </div>
           </div>
  }
}

export class ScrollList extends Component {
  constructor (props) {
    super(props)
  }
  onSlideChange = e => {
  }
  onSwiper = ref => {
    this.swiper = ref
  }
  render() {
    const left = () => {
      this.swiper.slideTo(this.swiper.activeIndex - 1)
    }
    const right = () => {
      this.swiper.slideTo(this.swiper.activeIndex +1)
    }
    return <div className='scrollList'>
             <div className='titleRow'>
               <div className='scrollListTitle'>{this.props.title}</div>
               <div className='scrollListChoice'>{this.props.choice}</div>
             </div>
             <div className='contentRow'>
               <SimpleButton icon={Left} action={left}/>
               <Swiper
                 preventClicks={false}
                 onSwiper={this.onSwiper}
                 modules={[Mousewheel]}
                 allowTouchMove={!isDesktop()}
                 onSlideChange={this.onSlideChange}
                 slidesPerView={'auto'}
                 mousewheel={isDesktop() ? { forceToAxis: true, releaseOnEdges: true  } : undefined}
               >
                 {this.props.children.map((x, i) => <SwiperSlide key={i}>{x}</SwiperSlide>)}
               </Swiper>
               <SimpleButton icon={Right} action={right}/>
             </div>
           </div>
  }
}


export const formatPrice = (price, N = 2) => {
  if (price <= 0) {
    return '0.00'
  }
  if (price >=  0.10) {
    return price.toFixed(2)
  }
  if (price <= 0.00001) {
    return '0.00001'
  }
  // Convert the price to a string and split at the decimal point
  let priceStr = price.toString();
  let [wholePart, decimalPart] = priceStr.split('.');
  
  if (!decimalPart) {
    return wholePart 
  }

  // Count leading zeros in the decimal part
  let leadingZeros = decimalPart.match(/^0*/)[0].length;
  
  // Calculate the total number of decimal places to keep
  let totalDecimals = leadingZeros + N;
  
  // Format the price with the calculated number of decimals
  let formattedPrice = price.toFixed(totalDecimals);

  // Remove trailing zeros
  formattedPrice = parseFloat(formattedPrice).toString();
  return formattedPrice;
}

export const ModelPrice = props => {
  const { price } = props
  return <div className='modelPriceStyle'>
           {price}
         </div>
}

export const ModelIcon = props => {
  const { model } = props
  const { getModelIcon, getIcon } = model
  let icon = (getModelIcon && getModelIcon()) || getIcon()
  return <SimpleIcon src={icon}/>
}

export const ModelLabel = props => {
  const { model } = props
  let version
  if (!model) {
    return "Undefined"
  }
  const { title, displayTitle, isFinetune, modelId, rootModel } = model 
  if (isFinetune) {
    function formatDate(date) {
      const momentDate = moment(date)
      const currentYear = moment().year();

      // Check if the year of the date matches the current year
      if (momentDate.year() === currentYear) {
        return momentDate.format('MM/DD');
      } else {
        return momentDate.format('MM/DD/YY');
      }
    }
    const date = formatDate(model.ts)
    version = <div className='modelVersion'><div className='modelVersionDate'>{date}</div><div className='modelVersionId'>{modelId}</div></div>
  }
  const label = displayTitle || title
  return <div className='modelLabel'>
           <div className='modelName'>{label}</div>
           {version} 
         </div>
  
}

export class Model extends Component {
  constructor (props) {
    super(props)
    this.state = {
      busy: false
    }
  }
  render() {
    let { model, single, active, action, button, preview } = this.props
    let { id, title, label, getIcon, vendor, getModelIcon, vision, legacy, isFinetune, modelId } = model
    
    const select = model.select || action
    const baseSelected = () => model.isSelected && model.isSelected()
    const selectedRuntimeConfig = this.props.getSelectedModelRuntimeConfig && this.props.getSelectedModelRuntimeConfig(model.id)
    const selectedRuntimeProviderId = runtimeSelectionProviderId(selectedRuntimeConfig)
    const displayInferenceProviderId = normalizeProviderId(model.displayInferenceProviderId)
    const isSelected = () => {
      if (!baseSelected()) {
        return false
      }
      if (!displayInferenceProviderId) {
        return true
      }
      if (selectedRuntimeProviderId) {
        return selectedRuntimeProviderId === displayInferenceProviderId
      }
      return getInferenceProviderIds(model).length <= 1
    }
    label = title
    let busy = this.state.busy || this.props.busy
    let iconStyle
    let icon = getModelIcon ? getModelIcon() : null
    if (single) {
      icon = icon || model.getIcon()
    } else if (!preview) {
      iconStyle = getModelIcon && getModelIcon() ? null : { visibility: 'hidden', maxWidth: 15 }
    } else {
      icon = icon || model.getIcon()
    }
    if (busy) {
      //debugger
      icon = Spin
    }
    let className= 'model'
    if (isSelected()) className += '  modelRadioButtonSelected'
    if (!single) {
      className += ' modelSubmenu'
    }
    if (preview) {
      className += ' modelPreview'
    }
    const format = this.props.formatPrice || formatPrice
    let price = this.props.price || ''
    if (this.props.getPrice) {
      price = formatPricePair(this.props.getPrice(model), format)
    }
    if (legacy) {
      className += ' modelLegacy'
    }
    let configure
    let configIcon = this.state.showConfiguration ? Up : Down
    if (this.props.configure) {
      configure = () => {
        this.setState({
          showConfiguration: !this.state.showConfiguration
        })
      }
    }
    let config
    if (this.state.showConfiguration) {
      config = this.props.configure(model)
    }
    //console.log('Model config', config, 'configure', this.props.configure)
    if (model.providerId === 'custom') {
      single = true
    }
    let vendorLabel
    if (single){
      vendorLabel = <div className='modelLabel modelVendorLabel'>{this.props.vendorLabel || model.modelProvider || vendor}</div>
    }
    const inferenceProviderIds = getInferenceProviderIds(model)
    const inferenceProviderNodes = providerNodesById(model.inferenceProviders)
    const inferenceProviderNames = getProviderNameList(inferenceProviderIds, this.props.vendors || [], providerNamesById(model.inferenceProviders))
    const inferenceProviders = inferenceProviderIds.map((id, i) => {
      let iconVendor = getProviderIconVendor(id, this.props.vendors || [])
      if (!iconVendor && isCustomModel(model)) {
        iconVendor = (this.props.vendors || []).find(vendor => normalizeProviderId(vendor.id) === 'custom')
      }
      const providerNode = inferenceProviderNodes[id] || {}
      return {
        ...providerNode,
        id,
        name: inferenceProviderNames[i],
        icon: iconVendor && iconVendor.getIcon ? iconVendor.getIcon() : null,
        contexts: providerNode.contexts
      }
    })
    const modelProviderId = getModelProviderId(model)
    const routeIndicator = this.props.getModelRouteIndicator && this.props.getModelRouteIndicator(
      model,
      displayInferenceProviderId || (inferenceProviderIds.length === 1 ? inferenceProviderIds[0] : undefined)
    )
    if (routeIndicator && routeIndicator.className) {
      className += ' ' + routeIndicator.className
    }
    if (displayInferenceProviderId) {
      className += ' modelInferenceSelection'
      if (this.props.hideInferenceProviderName) {
        className += ' modelInferenceSelectionIconOnly'
      }

      const displayProvider = inferenceProviders.find(provider => provider.id === displayInferenceProviderId) || {}
      const modelProviderIconVendor = this.props.showModelProviderIcon && getProviderIconVendor(modelProviderId, this.props.vendors || [])
      const providerIcon = modelProviderIconVendor && modelProviderIconVendor.getIcon
        ? modelProviderIconVendor.getIcon()
        : model.displayInferenceProviderIcon || displayProvider.icon
      const providerName = model.displayInferenceProviderName || displayProvider.name || getProviderName(displayInferenceProviderId, this.props.vendors || [], providerNamesById(model.inferenceProviders))
      const providerPrice = this.props.getInferenceProviderPrice && this.props.getInferenceProviderPrice(model, displayInferenceProviderId)
      const providerPriceLabel = displayProvider.displayPriceLabel || formatPricePair(providerPrice, format)
      const providerPriceClassName = 'modelInferenceSelectionPrice' + (routeIndicator && routeIndicator.className ? ' ' + routeIndicator.className : '')
      let customProviderName = providerName === "Custom" ? provider.title : null
      return <div className='configurableModel'>
               <div className={className} onClick={() => select(model)}>
                 <div className="modelSelectorLeft">
                   <div className='modelSelector modelInferenceSelectionSelector'>
                     <div className='modelInferenceSelectionProvider'>
                       {providerIcon && <SimpleIcon src={providerIcon}/>}
                       {customProviderName && <div className='modelInferenceSelectionProviderName'>{customProviderName}</div>}
                     </div>
                     <div className='modelInferenceSelectionModel'>
                       <ModelLabel model={model}/>
                     </div>
                   </div>
                 </div>
                 <div className='modelSelectorRight'>
                   <div className={providerPriceClassName}>{providerPriceLabel}</div>
                   <div className='modelInferenceSelectionVision'>
                     {!button && vision && <ReactSVG src={Image}/>}
                   </div>
                 </div>
               </div>
               {config}
             </div>
    }
    let inferenceProviderLabel
    const hasInferenceProviderBeyondModelProvider = inferenceProviderIds.find(id => id !== modelProviderId)
    const providerFilterMode = this.props.providerFilterMode || 'model'
    const isModelProviderMode = providerFilterMode === 'model'
    const hasMultipleInferenceProviders = inferenceProviderIds.length > 1
    const showInlineInferenceProviderIcon = isModelProviderMode && hasInferenceProviderBeyondModelProvider && !hasMultipleInferenceProviders
    const canExpandInferenceProviders = isModelProviderMode && hasMultipleInferenceProviders
    const inlineInferenceProvider = showInlineInferenceProviderIcon && inferenceProviders.find(provider => provider.id !== modelProviderId)
    if (inlineInferenceProvider && inlineInferenceProvider.icon) {
      icon = inlineInferenceProvider.icon
    }
    if (canExpandInferenceProviders) {
      className += ' modelWithInferenceDisclosure'
      price = ''
    }
    if (inferenceProviderNames.length && (inferenceProviderIds.length > 1 || inferenceProviderIds[0] !== modelProviderId)) {
      inferenceProviderLabel = inferenceProviderNames.length === 1
        ? 'via ' + inferenceProviderNames[0]
        : 'via ' + inferenceProviderNames[0] + ' +' + (inferenceProviderNames.length - 1)
    }
    let inferenceProviderControl
    let inferenceProviderDisclosure
    let inferenceProviderTree
    let selectModelOrProvider = () => select(model)
    if (inferenceProviderLabel) {
      const isProviderSelected = this.props.isInferenceProviderSelected || (() => false)
      const toggle = this.props.toggleInferenceProvider || (() => {})
      const renderInferenceProviderTreeItem = provider => {
        let className = 'modelInferenceProviderIconButton'
        let itemClassName = 'modelInferenceProviderTreeItem modelInferenceProviderTreeItemCompact'
        const providerRuntimeSelected = baseSelected() && selectedRuntimeProviderId === provider.id
        if (isProviderSelected(provider) || providerRuntimeSelected) {
          className += ' modelInferenceProviderIconButtonSelected'
          itemClassName += ' modelInferenceProviderTreeItemSelected'
        }
        const providerPrice = this.props.getInferenceProviderPrice && this.props.getInferenceProviderPrice(model, provider.id)
        const providerPriceLabel = provider.displayPriceLabel || formatPricePair(providerPrice, format)
        const providerRouteIndicator = this.props.getModelRouteIndicator && this.props.getModelRouteIndicator(model, provider.id)
        if (providerRouteIndicator && providerRouteIndicator.className) {
          itemClassName += ' ' + providerRouteIndicator.className
        }
        const providerPriceClassName = 'modelInferenceProviderTreePrice' + (providerRouteIndicator && providerRouteIndicator.className ? ' ' + providerRouteIndicator.className : '')
        return <div
                 key={provider.id}
                 className={itemClassName}
                 title={provider.name}
                 onClick={event => {
                   event.stopPropagation()
                   if (model.select) {
                     model.select({
                       ...model,
                       displayInferenceProviderId: provider.id,
                       displayInferenceProviderName: provider.name,
                       displayInferenceProviderIcon: provider.icon
                     })
                   } else {
                     toggle(provider)
                   }
                 }}>
                 <div className='modelSelectorLeft'>
                   <div className={className}>
                     {provider.icon && <SimpleIcon src={provider.icon}/>}
                   </div>
                   <div className='modelInferenceProviderTreeProvider'>{provider.name}</div>
                 </div>
                 <div className='modelSelectorRight'>
                   {providerPriceLabel && <div className={providerPriceClassName}>{providerPriceLabel}</div>}
                 </div>
               </div>
      }
      if (canExpandInferenceProviders) {
        const toggleInferenceTree = event => {
          event.stopPropagation()
          this.setState({
            inferenceProvidersExpanded: !this.state.inferenceProvidersExpanded
          })
        }
        selectModelOrProvider = toggleInferenceTree
        inferenceProviderDisclosure = <div className='modelInferenceProviderDisclosure' onClick={toggleInferenceTree}>
                                        <SimpleIcon src={this.state.inferenceProvidersExpanded ? Up : Down}/>
                                      </div>
        if (this.state.inferenceProvidersExpanded) {
          inferenceProviderTree = <div className='modelInferenceProviderTree' onClick={event => event.stopPropagation()}>
                                    {inferenceProviders.map(renderInferenceProviderTreeItem)}
                                  </div>
        }
      } else if (!showInlineInferenceProviderIcon) {
        inferenceProviderControl = <div
                                     className='modelInferenceProviderLabel'>
                                     {inferenceProviderLabel}
                                   </div>
      }
    }
    const priceClassName = 'modelPrice' + (routeIndicator && routeIndicator.className ? ' ' + routeIndicator.className : '')
    return <div className='configurableModel'>
             <div className={className} >
               <div className='modelSelector' onClick={selectModelOrProvider}>
                 <div className='modelLeft' >
                   <SimpleIcon src={icon}/>
                   <div className='modelVendorAndLabel'>
                     {vendorLabel}
                     <div className='modelLabelAndInferenceProviders'>
                       <ModelLabel model={model}/>
                     </div>
                     {inferenceProviderControl}
                   </div>
                 </div>
                 <div className={priceClassName}>
                   {price}
                 </div>
                 <div className='modelVision'>
                   {!button && vision && <ReactSVG src={Image}/>}
                 </div>
                 {inferenceProviderDisclosure}
               </div>
               {false &&<div className='modelRight'>
                 {configure && <SimpleButton icon={configIcon} action={configure}/>}
                        </div>}
             </div>
             {inferenceProviderTree}
             {config}
           </div>
  }
}


export class ModelVendor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: this.props.open
    }
    if (this.props.vendor.id === 'google') {
      //debugger
    }
  }

  toggleProviderGroup = providerId => {
    providerId = normalizeProviderId(providerId)
    const providerGroupsOpen = { ...(this.state.providerGroupsOpen || {}) }
    providerGroupsOpen[providerId] = !this.isProviderGroupOpen(providerId)
    this.setState({ providerGroupsOpen })
  }

  isProviderGroupOpen = providerId => {
    providerId = normalizeProviderId(providerId)
    const providerGroupsOpen = this.state.providerGroupsOpen || {}
    if (providerGroupsOpen.hasOwnProperty(providerId)) {
      return providerGroupsOpen[providerId]
    }
    return true
  }

  hasSearchTerm = () => {
    return String(this.props.searchTerm || '').trim().length > 0
  }

  isModelRowSelected = model => {
    if (!model || !model.isSelected || !model.isSelected()) {
      return false
    }
    const displayProviderId = normalizeProviderId(model.displayInferenceProviderId)
    if (!displayProviderId) {
      return true
    }
    const selectedRuntimeConfig = this.props.getSelectedModelRuntimeConfig && this.props.getSelectedModelRuntimeConfig(model.id)
    const selectedProviderId = runtimeSelectionProviderId(selectedRuntimeConfig)
    if (selectedProviderId) {
      return selectedProviderId === displayProviderId
    }
    return getInferenceProviderIds(model).length <= 1
  }

  renderModel = (model, preview, extraProps = {}) => {
    return <Model
             preview={preview}
             key={model.displayKey || model.id}
             me={this.props.me}
             model={model}
             configure={this.props.configure}
             vendors={this.props.vendors}
             providerFilterMode={this.props.providerFilterMode}
             isInferenceProviderSelected={this.props.isInferenceProviderSelected}
             toggleInferenceProvider={this.props.toggleInferenceProvider}
             getInferenceProviderPrice={this.props.getInferenceProviderPrice}
             getSelectedModelRuntimeConfig={this.props.getSelectedModelRuntimeConfig}
             getModelRouteIndicator={this.props.getModelRouteIndicator}
             formatPrice={this.props.formatPrice}
             getPrice={this.props.getPrice}
             {...extraProps}/>
  }

  renderInferenceProviderGroups = (models, preview) => {
    const groups = {}
    const groupOrder = {}
    for (const providerId of this.props.vendor.providerIds || []) {
      groupOrder[normalizeProviderId(providerId)] = Object.keys(groupOrder).length
    }
    for (const model of models) {
      const providerId = normalizeProviderId(model.displayInferenceProviderId)
      if (!providerId) {
        continue
      }
      if (!groups[providerId]) {
        const providerNames = providerNamesById(model.inferenceProviders)
        const providerOption = createProviderOption(providerId, this.props.vendors, providerNames)
        groups[providerId] = {
          id: providerId,
          name: model.displayInferenceProviderName || providerOption && providerOption.name || getProviderName(providerId, this.props.vendors, providerNames),
          icon: model.displayInferenceProviderIcon || providerOption && providerOption.getIcon && providerOption.getIcon(),
          routeClassName: providerOption && providerOption.routeClassName || getProviderRouteClassName(providerId),
          models: []
        }
      }
      groups[providerId].models.push(model)
    }
    const parentName = String(this.props.vendor.name || '').trim().toLowerCase()
    const sortedGroups = Object.values(groups).sort((x, y) => {
      const orderX = groupOrder.hasOwnProperty(x.id) ? groupOrder[x.id] : 1000
      const orderY = groupOrder.hasOwnProperty(y.id) ? groupOrder[y.id] : 1000
      let cmp = orderX - orderY
      if (cmp) {
        return cmp
      }
      return x.name.localeCompare(y.name)
    })
    const renderInferenceModel = model => this.renderModel(model, preview, {
      hideInferenceProviderName: true,
      showModelProviderIcon: true
    })
    if (sortedGroups.length === 1 && String(sortedGroups[0].name || '').trim().toLowerCase() === parentName) {
      return <div className='modelInferenceDirectProviderModels'>
               {sortedGroups[0].models.map(renderInferenceModel)}
             </div>
    }
    return sortedGroups.map(group => {
      if (this.hasSearchTerm() && group.models.length === 1) {
        return this.renderModel(group.models[0], preview)
      }
      const open = this.isProviderGroupOpen(group.id)
      const hideName = String(group.name || '').trim().toLowerCase() === parentName
      const selectedModelIds = {}
      group.models.forEach(model => {
        if (this.isModelRowSelected(model)) {
          selectedModelIds[model.id] = true
        }
      })
      const selectionCount = Object.keys(selectedModelIds).length
      return <div key={group.id} className={'modelInferenceRuntimeProvider' + (open ? ' modelInferenceRuntimeProviderOpen' : '')}>
               <div className={'modelCategoryMenu modelInferenceRuntimeProviderMenu' + (group.routeClassName ? ' ' + group.routeClassName : '') + (selectionCount ? ' modelRadioButtonSelected' : '')} onClick={() => this.toggleProviderGroup(group.id)}>
                 <div className='modelCategoryLeft modelInferenceRuntimeProviderLeft'>
                   <div className='modelIcon'>
                     {group.icon && <SimpleIcon src={group.icon}/>}
                   </div>
                   {!hideName && <div className='modelLabel modelVendorLabel'>{group.name}</div>}
                 </div>
                 <div className='modelCategoryRight'>
                   {selectionCount > 0 && <div className='modelVendorSelectionCountContainer'><div className='modelVendorSelectionCount'>{selectionCount}</div><div className='modelVendorCheck'><ReactSVG src={CheckMark}/></div></div>}
                   <div className='modelIconOpen'>
                     <SimpleIcon src={open ? Up : Down}/>
                   </div>
                 </div>
               </div>
               {open && <div className='modelInferenceRuntimeProviderModels'>
                          {group.models.map(renderInferenceModel)}
                        </div>}
             </div>
    })
  }

  renderModels(preview) {
    const getPrice = m => this.props.getPrice ? this.props.getPrice(m) || { input: 0, output: 0 } : { input: 0, output: 0 }
    let models = [].concat(this.props.models)
    if (this.props.preview) {
      models = models.filter(x => {
        return getPrice(x).input
      })
    }
    const byId = {}
    models.forEach(m => {
      byId[m.id] = m
    })
    const isDerivedFrom = (x, y) => {
      if (x.isFinetune) {
        return x.rootModel == y.id
      }
    }
    models.sort((x, y) => {
      if (isDerivedFrom(x, y)) {
        return x
      }
      if (isDerivedFrom(y, x)) {
        return y
      }
      const price1 = getPrice(x)
      const price2 = getPrice(y)
      let cmp = price2.input - price1.input
      if (cmp) {
        return cmp
      }
      if (y.isFinetune && !x.isFinetune) {
        return x
      }
      else if (x.isFinetune && !y.isFinetune) {
        return y
      } 
      cmp = y.ts - x.ts
      if (cmp) {
        return cmp
      }
      return x.title.localeCompare(y.title)
    })
    ////console.log({sortedModels: models})
    if (!preview && this.props.providerFilterMode === 'inference') {
      return this.renderInferenceProviderGroups(models, preview)
    }
    return models.map(model => this.renderModel(model, preview))
  }
  toggleMenu = () => {
    this.setState({
      open: !this.state.open
    })
  }
  render() {
    const open = this.state.open
    const { models } = this.props
    if (this.props.preview) {
      return this.renderModels(true)
    }
    //////console.log({models})
    const format = this.props.formatPrice || formatPrice
    const selectedModelIds = {}
    models.forEach(model => {
      if (this.isModelRowSelected(model)) {
        selectedModelIds[model.id] = true
      }
    })
    let selectionCount = Object.keys(selectedModelIds).length
    let isSelected = selectionCount > 0
    const collapseSingleResult = !this.props.preview &&
      models.length === 1 &&
      (this.props.providerFilterMode !== 'inference' || this.hasSearchTerm())
    if (collapseSingleResult) {
      return <Model
               configure={this.props.configure}
               key={models[0].displayKey || models[0].id}
               me={this.props.me}
               model={models[0]}
               single={true}
               vendorLabel={this.props.vendor.name}
               vendors={this.props.vendors}
               providerFilterMode={this.props.providerFilterMode}
               isInferenceProviderSelected={this.props.isInferenceProviderSelected}
               toggleInferenceProvider={this.props.toggleInferenceProvider}
               getInferenceProviderPrice={this.props.getInferenceProviderPrice}
               getSelectedModelRuntimeConfig={this.props.getSelectedModelRuntimeConfig}
               getModelRouteIndicator={this.props.getModelRouteIndicator}
               getPrice={this.props.getPrice}
               formatPrice={this.props.formatPrice}/>
    }
    let style
    if (models.length === 0) {
      style = {display: 'none'}
    }
    let price
    let openStyle = null
    ////console.log({models})
    if (this.props.aggregatePrice) {
      const { input, output } = this.props.aggregatePrice
      price = "$" + format(input) + "/" + format(output)
    }
    return <div className={'modelCategory' + (open ? ' modelCategoryOpen' : '')} style={style}>
             <div className={'modelCategoryMenu' + (isSelected ? ' modelRadioButtonSelected' : '')} onClick={this.toggleMenu}>
               <div className='modelCategoryLeft'>
                 <div className='modelIcon'>
                   <SimpleIcon src={this.props.vendor.getIcon()}/>
                 </div>
                 <div className='modelLabel modelVendorLabel'>
                   {this.props.vendor.name}
                 </div>
               </div>
               <div className='modelCategoryRight'>
                 {price && <div className='modelPrice'>{price}</div>}
                 {selectionCount > 0 && <div className='modelVendorSelectionCountContainer'><div className='modelVendorSelectionCount'>{selectionCount}</div><div className='modelVendorCheck'><ReactSVG src={CheckMark}/></div></div>}
                 <div className='modelIconOpen' style={openStyle}>
                   <SimpleIcon src={open ? Up : Down}/>
                 </div>
               </div>
             </div>
             {open && <div className='modelCategoryButtons'>
                         {this.renderModels(this.props.preview)}
                       </div>}
           </div>
  }
}


export class ModelsMenu extends UComponent {
  constructor(props) {
    super(props)
    this.state = {
      menuActive: true,
      providerFilterMode: 'model'
    }
  }


  setScrollRef = ref => {
    this.scrollRef = ref
  }
    
  renderMenu = (close, contentStyle) => {
    let style = contentStyle
    let ref = document.getElementById('modelMenuTrigger')
    let selectedModel
    const selectModel = (model) => {
      model.select()
      close()
    }
    const closeMenu = () => this.setState({menuActive: false})
    const isLarge = () => {
      return this.props.sizes['large']
    }
    const isMedium = () => {
      return this.props.sizes['medium']
    }
    const isSmall = () => {
      return this.props.sizes['small']
    }
    const selectedModels = this.props.modelsForSelection.filter(model => {
      return this.props.selectedModels[model.id]
    })

    
    const toggleLarge = () => {
      this.props.toggleLarge()
    }
    const toggleMedium = () => {
      this.props.toggleMedium()
    }
    const toggleSmall = () => {
      this.props.toggleSmall()
    }
    const isVision = () => {
      return this.props.isVision
    }
    const toggleVision = () => {
      this.props.toggleVision()
    }
    const isImage = () => {
      return this.props.isImage
    }
    const toggleImage = () => {
      this.props.toggleImage()
    }
    const isClosed = () => {
      return this.props.isClosed
    }
    const toggleClosed = () => {
      this.props.toggleClosed()
    }
    const isBase = () => {
      return this.props.isBase
    }
    const isReasoning = () => {
      return this.props.isReasoning
    }
    const toggleReasoning = () => {
      this.props.toggleReasoning()
    }
    const toggleBase = () => {
      this.props.toggleBase()
    }
    const isLegacy = () => {
      return this.props.isLegacy
    }
    const toggleLegacy = () => {
      this.props.toggleLegacy()
    }
    const getCheckpoints = () => {
      return this.props.checkpoints
    }
    const toggleCheckpoints = () => {
      return this.props.toggleCheckpoints()
    }
    const isFinetune = (model) => {
      return this.props.isFinetune(model)
    }
    const toggleFinetune = (model) => {
      this.props.toggleFinetune(model)
    }
    const isFinetunable = () => {
      return this.props.isFinetunable
    }
    const toggleFinetunable = () => {
      this.props.toggleFinetunable()
    }
    
    const isInstruct = () => {
      return this.props.isInstruct
    }
    const toggleInstruct = () => {
      this.props.toggleInstruct()
    }
    const supportsContext = context => {
      return context === this.props.inputContext
    }
    const toggleContext = context => {
      this.props.setInputContext(context)
    }
    const supportsOutputContext = context => {
      return context ===this.props.outputContext
    }
    const toggleOutputContext = context => {
      this.props.setOutputContext(context)
    }
    const supportsPrice = context => {
      return context === this.props.inputPrice
    }
    const togglePrice = context => {
      this.props.setInputPrice(context)
    }
    let className = 'chatGptModelsMenu'
    if (isDesktop()) {
      className += ' chatGptModelsMenuDesktop'
    }
    if (this.props.className) {
      className += ' ' + this.props.className
    }
      
    //////console.log('modelsMenu', {selectedModels, propsSelectedModels: this.props.selectedModels})
    const Finetunable = {}
    let finetunables = []
    for (const model of this.props.modelsForSelection) {
      if (model.finetune && !model.isFinetune) {
        if (!Finetunable[model.id]) {
          Finetunable[model.id] = model
          finetunables.push(model)
        }
      }
    }
    const finetunable = finetunables.length > 0
    let done
    let clear
    if (!this.props.inline) {
      done = () => this.hidePopup()
      clear = () => {
        this.props.clearOptions()
      }
    }
    if (this.props.preview) {
      className += ' modelsMenuPreview'
    }
    if (this.props.unselectable) {
      className += ' modelsMenuNoSelect'
    }
    if (this.props.vendorOnly) {
      className += ' modelsMenuVendorOnly'
    }
    let vendorItems
    if (this.props.inline && !this.props.preview && isDesktop()) {
    } else {
      vendorItems = this.props.renderVendorItems()
      vendorItems = <div className='vendorItemsInline'>{vendorItems}</div>
    }
    let checkpointsOption
    if (finetunables && finetunables.find(model => model.vendorId === 'openai'
                                          && isFinetune(model.id))) {
      checkpointsOption = <Checkbox label={"Checkpoints"} toggle={toggleCheckpoints} selected={getCheckpoints()}/>
    }
    const renderProviderButtons = ({ providers, isSelected, toggle, labeled }) => {
      providers = providers || []
      if (!providers.length) {
        return null
      }
      isSelected = isSelected || (() => false)
      toggle = toggle || (() => {})
      return <div className='chatGptThreadsVendorOptions'>
               {
                 providers.map(provider => {
                   const selected = isSelected(provider)
                   let className = 'modelsMenuVendor'
                   if (provider.routeClassName) {
                     className += ' ' + provider.routeClassName
                   }
                   if (selected) {
                     className += ' modelsMenuVendorSelected'
                   }
                   const n = providers.length
                   const showLabel = labeled || provider.showLabel
                   if (showLabel) {
                     className += ' modelsMenuVendorLabeled'
                   }
                   const minWidth = showLabel ? undefined : `calc(max(32px, (100%  - ${n-1} * 4px) / ${n}))`
                   const style = minWidth ? { minWidth } : undefined
                   const icon = provider.getIcon && provider.getIcon()
                   return <div
                            key={provider.id}
                            className={className}
                            style={style}
                            title={provider.name}
                            onClick={() => toggle(provider)}>
                            <div className='modelsMenuProviderButton'>
                              <SimpleIcon src={icon}/>
                            </div>
                          </div>
                 })
               }
             </div>
    }
    const modelProviders = this.props.modelProviders || this.props.vendors
    const inferenceProviders = this.props.inferenceProviders
    const providerFilterMode = this.props.providerFilterMode || this.state.providerFilterMode || 'model'
    const providerRail = providerFilterMode === 'inference'
      ? {
        providers: inferenceProviders,
        isSelected: this.props.isInferenceProviderSelected,
        toggle: this.props.toggleInferenceProvider
      }
      : {
        providers: modelProviders,
        isSelected: this.props.isVendorSelected,
        toggle: this.props.toggleVendor
      }
    const setProviderFilterMode = mode => {
      if (this.props.setProviderFilterMode) {
        this.props.setProviderFilterMode(mode)
      } else {
        this.setState({ providerFilterMode: mode })
      }
    }
    const renderProviderModeButton = (mode, label) => {
      let className = 'modelsMenuProviderModeButton'
      if (providerFilterMode === mode) {
        className += ' modelsMenuProviderModeButtonSelected'
      }
      return <div className={className} onClick={() => setProviderFilterMode(mode)}>{label}</div>
    }
    let show
    return <div className={className} style={style}>
             <div className='chatGptThreadsMenuOptionsContainer modelOptionsTitle'>
             </div>
             <div className='chatGptThreadsMenuOptionsContainer modelsMenuProviderRows'>
               <div className='modelsMenuProviderModeButtons'>
                 {renderProviderModeButton('model', 'Model')}
                 {renderProviderModeButton('inference', 'Inference')}
               </div>
               <div className='modelsMenuProviderIconRail'>
                 {renderProviderButtons({
                   providers: providerRail.providers,
                   isSelected: providerRail.isSelected,
                   toggle: providerRail.toggle
                 })}
               </div>
             </div>
             <div className='chatGptThreadsMenuOptionsContainer modelOptionsContainer'>
               <div className='chatGptThreadsMenuOptions modelsMenuOptionsSize'>
                 <div className='modelsMenuGroup'>
                   <Checkbox selected={isSmall()} toggle={toggleSmall} label='Small'/>
                   <Checkbox selected={isMedium()} toggle={toggleMedium} label={'Medium'}/>
                   <Checkbox selected={isLarge()} toggle={toggleLarge} label='Large'/>
                 </div>
                 <div className='modelsMenuGroup'>
                   <Checkbox legacyIconSize icon={Image} selected={isVision()} toggle={toggleVision} label='Vision'/>
                   <Checkbox selected={isReasoning()} toggle={toggleReasoning} label='Reasoning'/>
                   {false && <Checkbox selected={isBase()} toggle={toggleBase} label='Base'/>}
                   {false && <Checkbox className='finetunableModel' selected={isFinetunable()} toggle={toggleFinetunable} label='Fine-tunable'/>}
                   <Checkbox className='legacy' selected={isLegacy()} toggle={toggleLegacy} label='Legacy'/>
                 </div>
               </div>
               <div className='chatGptThreadsMenuOptions modelsMenuOptionsInputContext'>
                 <div className='optionLabel'>Input</div>
                 <Checkbox selected={supportsContext(4)} toggle={() => toggleContext(4)} label={'4K'}/>
                 <Checkbox selected={supportsContext(8)} toggle={() => toggleContext(8)} label={'8K'}/>
                 <Checkbox selected={supportsContext(16)} toggle={() => toggleContext(16)} label='16K'/>
                 <Checkbox selected={supportsContext(128)} toggle={() => toggleContext(128)} label='128K'/>
                 <Checkbox selected={supportsContext(256)} toggle={() => toggleContext(256)} label='200K'/>
                 <Checkbox selected={supportsContext(1000)} toggle={() => toggleContext(1000)} label='1M'/>
                 <Checkbox selected={supportsContext(2000)} toggle={() => toggleContext(2000)} label='2M'/>
               </div>
               <div className='chatGptThreadsMenuOptions modelsMenuOptionsOutputContext'>
                 <div className='optionLabel'>Output</div>
                 <Checkbox selected={supportsOutputContext(4)} toggle={() => toggleOutputContext(4)} label={'4K'}/>
                 <Checkbox selected={supportsOutputContext(8)} toggle={() => toggleOutputContext(8)} label={'8K'}/>
                 <Checkbox selected={supportsOutputContext(16)} toggle={() => toggleOutputContext(16)} label='16K'/>
               </div>
               <div className='chatGptThreadsMenuOptions modelsMenuOptionsPrice'>
                 <ScrollList title={'Max Price'} choice={this.props.inputPrice ? <div className='inputPrice'>${this.props.inputPrice.toFixed(2)}</div> : ''}>
                   <Checkbox selected={supportsPrice(0)} toggle={() => togglePrice(0)} label='None'/>
                   <Checkbox selected={supportsPrice(.10)} toggle={() => togglePrice(.10)} label={'.10'}/>
                   <Checkbox selected={supportsPrice(.15)} toggle={() => togglePrice(.15)} label={'.15'}/>
                   <Checkbox selected={supportsPrice(.30)} toggle={() => togglePrice(.30)} label={'.30'}/>
                   <Checkbox selected={supportsPrice(1)} toggle={() => togglePrice(1)} label='$1'/>
                   <Checkbox selected={supportsPrice(2)} toggle={() => togglePrice(2)} label='$2'/>
                   <Checkbox selected={supportsPrice(3)} toggle={() => togglePrice(3)} label='$3'/>
                   <Checkbox selected={supportsPrice(4)} toggle={() => togglePrice(4)} label='$4'/>
                   <Checkbox selected={supportsPrice(5)} toggle={() => togglePrice(5)} label='$5'/>
                   <Checkbox selected={supportsPrice(10)} toggle={() => togglePrice(10)} label='$10'/>
                   <Checkbox selected={supportsPrice(20)} toggle={() => togglePrice(20)} label='$20'/>
                 </ScrollList>
               </div>
               {false && finetunable &&<div className='chatGptThreadsMenuOptions modelsMenuOptionsFineTuning'>
                                <ScrollList title={"Fine-tuned"}  choice={checkpointsOption}>
                                  {
                                    finetunables.map(model => {
                                      let icon = (model.getModelIcon && model.getModelIcon()) || model.getIcon()
                                      return <Checkbox icon={icon} selected={isFinetune(model.id)} toggle={() => toggleFinetune(model.id)} label={model.name}/>
                                    })
                                  }
                                </ScrollList>
                              </div>
               }
             </div>
             {vendorItems}
             <div className='modelsMenuButtons'>
               {this.props.children}
             </div>
           </div>
    
  }

  renderFineTuned = () => {
  }


  setPopupRef = ref => {
    this.popupRef = ref
  }

  openMenu = () => {
  }

  openIfNecessary = () => {
  }

  showPopup = () => {
    this.popupRef.open()
  }

  hidePopup = () => {
    this.popupRef.close()
  }

  togglePopup = () => {
    ////console.log("togglePopup", this.open)
    if (this.open) {
      this.hidePopup()
    } else {
      this.showPopup()
    }
  }

  componentDidMount() {
    this.state.closeOnClick = !this.props.menuActive
    this.props.onCreate(this)
  }

  componentDidUpdate() {
    if (this.popupRef && this.props.menuActive) {
      setTimeout(this.popupRef.open, 500)
    } else {
    }
  }

  setRef = ref => {
    this.ref = ref
  }

  render() {
    if (this.props.inline) {
      let className = 'modelsMenuInline'
      if (this.props.preview) {
        className += ' modelsMenuInlinePreview'
      }
      return <div className={className}>
               {this.renderMenu()}
             </div>
    }
    let position = 'bottom left'
    let contentStyle
    ////console.log("modelsmenu.ref", this.ref)
    if (this.ref) {
      const rect = this.ref.getBoundingClientRect()
      if (rect.top > window.innerHeight * .55) {
        position = "top left" 
        const h = rect.top - 40
        contentStyle = {
          maxHeight: h - 32,
          overflowY: 'auto',
        }
      } else {
        position = 'bottom left'
        const h = window.innerHeight - Math.max(rect.top + 40, rect.bottom) 
        contentStyle = {
          maxHeight: h - 32,
          overflowY: 'auto',
        }
      }
      ////console.log("buttonRef", rect, contentStyle)
    }
    let icon
    if (this.props.getIcon) {
      icon = this.props.getIcon(this.state.menuActive)
    } else {
      icon = this.props.menuActive || this.state.menuActive ? MenuDown : MenuUp
    }
    const trigger = <div id={'modelMenuTrigger'} className='keyboardAddButton'>
                      <KeyboardButton1 icon={icon} action={async () => {}  }/>
                    </div>
    let t
    return <div className='modelMenuPopupHolder' ref={this.setRef}>
             <Popup ref={this.setPopupRef} closeOnDocumentClick trigger={trigger} position={position} onOpen={() => {
                      this.open = true
                    }}
                    onClose={() => {
                      clearTimeout(t)
                      t= setTimeout(() => {
                        this.open = false
                        ////console.log("on close popup")
                      }, 40)
                    }}>
               {close => this.renderMenu(close, contentStyle)}
             </Popup>
           </div>
  }
}


export class ModelsView extends BnSubpage {

  constructor (props) {
    super(props)
    this.state = {
      options: {
      }
    }
    if (!this.props.category) {
      throw new Error("category is required")
    }
    this.state.options[this.props.category] = {
      ts: 0,
      temperature: 1.0,
      top_p: 1.0,
      baseModels: false,
      visionModels: false,
      legacyModels: false,
      selectedModels: {},
      selectedModelRuntimeOptions: {},
      selectedVendors: {},
      selectedInferenceProviders: {},
      selectedFinetunes: {},
      sizes: { },
      inputContext: 4,
      outputContext: 4,
      inputPrice: 30
    }
    //////console.log('state options', this.state.options)
  }
  
  saveOptionsLater = () =>  {
    this.forceUpdate()
    if (!this.props.saveOptions) {
      return
    }
    //this.props.onOptionsChanged()
    this.state.options.ts = Date.now()    
    this.updateLater('saveOptions', () => this.props.saveOptions(this.state.options))
  }

  onSearch = searchTerm => {
    //debugger
    this.state.searchTerm = searchTerm
    this.invalidateFilterCache()
    this.forceUpdate()
  }

  renderHeader() {
    if (this.props.preview) {
      return
    }
    return <SearchField onSearch={this.onSearch}/>
  }

  clearOptions = () => {
    this.state.options[this.props.category] = {
      ts: Date.now(),
      temperature: 1.0,
      top_p: 1.0,
      baseModels: false,
      visionModels: false,
      legacyModels: false,
      selectedModels: {},
      selectedModelRuntimeOptions: {},
      selectedVendors: {},
      selectedInferenceProviders: {},
      selectedFinetunes: {},
      sizes: { },
      inputContext: 4,
      outputContext: 4,
      inputPrice: 20
    }
    this.invalidateFilterCache()
    this.forceUpdate(this.onOptionsChanged)
    this.saveOptionsLater()
  }

  getOptions = () => {
    if (!this.state.options[this.props.category]) {
      this.state.options[this.props.category] = {
        ts: 0,
        temperature: 1.0,
        top_p: 1.0,
        baseModels: false,
        visionModels: false,
        legacyModels: false,
        reasoningModels: false,
        selectedModels: {},
        selectedModelRuntimeOptions: {},
        selectedVendors: {
        },
        selectedInferenceProviders: {},
        selectedFinetunes: {},
        sizes: { },
        inputContext: 4,
        outputContext: 4,
        inputPrice: 0
      }
      if (this.props.vendors && this.props.singleSelect) {
        const vendor = this.props.vendors[0]
        if (vendor) {
          this.state.options[this.props.category].selectedVendors = {
            [vendor.id]: true
          }
        }
      }
    }
    const result = this.state.options[this.props.category]
    if (!result.selectedInferenceProviders) {
      result.selectedInferenceProviders = {}
    }
    if (!result.selectedVendors) {
      result.selectedVendors = {}
    }
    if (!result.selectedModelRuntimeOptions) {
      result.selectedModelRuntimeOptions = {}
    }
    //////console.log("get options", this.props.category, this.state.options, result)
    return result
  }
  
  saveOptions = async () => {
    this.state.options.ts = Date.now()
    await this.props.saveOptions(this.state.options)
  }

  componentDidMount() {
    this.observeOptions()
    if (this.props.onCreate) this.props.onCreate(this)
    if (this.props.observeModels) {
      this.modelsSub = this.props.observeModels().subscribe(change => {
        console.log("MODELS CHANGED", change)
        this.invalidateSourceCache()
        this.forceUpdate()
      })
    }
  }

  componentWillUnmount() {
    if (this.optionsSub) {
      this.optionsSub.unsubscribe()
    }
  }

  componentDidUpdate(prevProps) {
    const sourceChanged = providerListSignature(prevProps.vendors) !== providerListSignature(this.props.vendors) ||
      hostListSignature(prevProps.hosts) !== hostListSignature(this.props.hosts) ||
      oauthSignature(prevProps.openAICodexOAuth) !== oauthSignature(this.props.openAICodexOAuth) ||
      (!this.props.observeModels && prevProps.models !== this.props.models)
    if (sourceChanged) {
      this.invalidateSourceCache()
      this.forceUpdate()
      return
    }
    if (prevProps.prices !== this.props.prices) {
      this.invalidateFilterCache()
      this.forceUpdate()
    }
  }

  observeOptions = () => {
    this.invalidateFilterCache()
    this.optionsSub = this.props.observeOptions().subscribe(data => {
      let { options } = data
      //////console.log("models menu observe options", this.props.category, options)
      //debugger
      this.updateOptionsLater(options)      
    })
  }

  updateOptionsLater = options => {
    this.updateLater('updateOptions', () => this.updateOptions(options))
  }

  invalidate = () => {
    this.invalidateSourceCache()
  }

  invalidateFilterCache = () => {
    this.selectedModelsList = null
    this.selectedModelsListCacheKey = null
    this.selectedModelIds = null
    this.selectedModelsListFiltered = null
    this.selectedModelsListFilteredCacheKey = null
    this.vendorGroups = null
    this.vendorGroupsCacheKey = null
    this.vendorItems = null
    this.vendorItemsCacheKey = null
    this.modelPriceCache = null
    this.modelPriceCacheKey = null
  }

  invalidateSourceCache = () => {
    this.invalidateFilterCache()
    this.models = null
    this.modelsById = null
    this.modelsSourceCacheKey = null
    this.modelProviderOptions = null
    this.inferenceProviderOptions = null
  }

  updateOptions = options => {
    if (options && this.state.options) {
      if (options.ts !== this.state.options.ts) {
        //console.log("options ts changed")
        const opts = options[this.props.category]
        if (opts) {
          const modelProviders = this.getModelProviderOptions()
          const inferenceProviders = this.getInferenceProviderOptions()
          const inferenceProviderIds = new Set(inferenceProviders.map(provider => provider.id))
          for (const model of this.getModels()) {
            for (const id of getInferenceProviderIds(model)) {
              inferenceProviderIds.add(id)
            }
            if (isCustomModel(model)) {
              inferenceProviderIds.add('custom')
            }
          }
          if (opts.selectedVendors) {
            for (const id in opts.selectedVendors) {
              if (!modelProviders.find(z => z.id == id)) {
                opts.selectedVendors[id] = null
              }
            }
          }
          if (!opts.selectedInferenceProviders) {
            opts.selectedInferenceProviders = {}
          }
          if (!opts.selectedModelRuntimeOptions) {
            opts.selectedModelRuntimeOptions = {}
          }
          for (const id in opts.selectedInferenceProviders) {
            if (!inferenceProviderIds.has(id)) {
              opts.selectedInferenceProviders[id] = null
            }
          }
        }
        this.setState({
          options
        },() => {
          this.invalidateFilterCache()
          this.props.onOptionsChanged(this.state.options)
        })
      }
    }
  }

  hasVendorSelected = () => {
    const options = this.getOptions()
    for (const id in options.selectedVendors) {
      if (options.selectedVendors[id]) {
        console.log("vendor selected: " + id)
        return true
      }
    }
  }

  hasInferenceProviderSelected = () => {
    return getSelectedProviderCount(this.getSelectedInferenceProviderMap()) > 0
  }
  
  getRuntimeConfigForSelection = model => {
    if (!model) {
      return null
    }
    const providerIds = getInferenceProviderIds(model)
    const providerId = model.displayInferenceProviderId || (providerIds.length === 1 ? providerIds[0] : null)
    return providerId ? runtimeConfigForProvider(model, providerId) : null
  }

  setSelectedModelRuntimeConfig = (modelId, config) => {
    const options = this.getOptions()
    if (!options.selectedModelRuntimeOptions) {
      options.selectedModelRuntimeOptions = {}
    }
    if (config) {
      options.selectedModelRuntimeOptions[modelId] = config
    } else {
      delete options.selectedModelRuntimeOptions[modelId]
    }
  }

  getSelectedModelRuntimeConfig = modelId => {
    const options = this.getOptions()
    return options.selectedModelRuntimeOptions && options.selectedModelRuntimeOptions[modelId]
  }

  getSelectedModelRequestConfigs = modelIds => {
    const result = {}
    for (const modelId of modelIds || []) {
      const model = this.modelsById[modelId]
      let runtimeConfig = this.getSelectedModelRuntimeConfig(modelId)
      const selectedProviderId = runtimeSelectionProviderId(runtimeConfig)
      if (model && selectedProviderId) {
        const currentProviderConfig = runtimeConfigForProvider(model, selectedProviderId)
        if (currentProviderConfig) {
          runtimeConfig = {
            ...runtimeConfig,
            ...currentProviderConfig
          }
        }
      }
      if (!runtimeConfig && model) {
        const providerIds = getInferenceProviderIds(model)
        if (providerIds.length === 1) {
          runtimeConfig = runtimeConfigForProvider(model, providerIds[0])
        }
      }
      const requestConfig = pickModelRouteConfig(runtimeConfig)
      if (requestConfig) result[modelId] = requestConfig
    }
    return result
  }

  getMissingInferenceProviderSelections = modelIds => {
    const requestConfigs = this.getSelectedModelRequestConfigs(modelIds)
    return (modelIds || []).filter(modelId => {
      const model = this.modelsById[modelId]
      return model && getInferenceProviderIds(model).length > 0 && !requestConfigs[modelId]
    })
  }

  applySelectedRuntimeConfig = model => {
    const config = model && this.getSelectedModelRuntimeConfig(model.id)
    if (!config) {
      return model
    }
    const fields = [
      'runtimeModelId',
      'inferenceProviderId',
      'inferenceProvider',
      'providerCompatibility',
      'apiBase',
      'modelsDevProviderId',
      'supportedReasoningEfforts',
      'defaultReasoningEffort',
      'supportedPricingModes',
    'defaultPricingMode',
    'supportedVerbosityLevels',
    'defaultVerbosityLevel',
      'displayInferenceProviderId',
      'displayInferenceProviderName',
      'displayPriceLabel',
      'billingModelId',
      'hostLabel',
      'virtualInferenceProvider',
      'actualInferenceProviderId',
      'routeInferenceProviderId',
      'desktopHostId',
      'promptTemplate'
    ]
    const next = { ...model }
    fields.forEach(field => {
      if (config[field] !== undefined) {
        next[field] = config[field]
      }
    })
    return next
  }

  selectModel = (model) => {
    const selectedRow = model && typeof model === 'object' ? model : null
    const modelId = selectedRow ? selectedRow.id : model
    const options = this.getOptions()
    if (this.props.singleSelect) {
      for (const id in options.selectedModels || {}) {
        if (id !== modelId) {
          options.selectedModels[id] = null
        }
      }
      for (const id in options.selectedModelRuntimeOptions || {}) {
        if (id !== modelId) {
          delete options.selectedModelRuntimeOptions[id]
        }
      }
    }
    const runtimeConfig = this.getRuntimeConfigForSelection(selectedRow)
    const existingRuntimeConfig = this.getSelectedModelRuntimeConfig(modelId)
    const isSelected = this.isModelSelected(modelId)
    const existingRuntimeProviderId = runtimeSelectionProviderId(existingRuntimeConfig)
    const runtimeProviderId = runtimeSelectionProviderId(runtimeConfig)
    if (isSelected && runtimeConfig && (!existingRuntimeConfig || existingRuntimeProviderId !== runtimeProviderId)) {
      this.setSelectedModelRuntimeConfig(modelId, runtimeConfig)
      this.invalidateFilterCache()
      this.forceUpdate1(this.saveOptionsLater)
      return
    }
    //debugger
    if (!isSelected) {
      if (runtimeConfig) {
        this.setSelectedModelRuntimeConfig(modelId, runtimeConfig)
      } else {
        this.setSelectedModelRuntimeConfig(modelId, null)
      }
      const m = this.modelsById[modelId]
      const modelProviderId = getModelProviderId(m)
      if ((this.state.providerFilterMode || 'model') === 'model' && this.hasVendorSelected() && !this.isVendorSelected({id: modelProviderId})) {
        this.toggleOption2('selectedVendors', modelProviderId)
      }
      const inferenceProviderIds = getInferenceProviderIds(m)
      const runtimeSelectionIds = runtimeProviderId ? [runtimeProviderId] : inferenceProviderIds
      if ((this.state.providerFilterMode || 'model') === 'inference' && this.hasInferenceProviderSelected() && !providerIntersectsSelection(runtimeSelectionIds, this.getSelectedInferenceProviderMap(), isCustomModel(m))) {
        this.toggleOption2('selectedInferenceProviders', runtimeSelectionIds[0])
      }
      if (m.finetune && !this.isFinetune(m.rootModel)) {
        this.toggleFinetune(m.rootModel)
      }
      if (m.legacy && !this.isLegacy()) {
        this.toggleLegacy()
      }
    } else {
      this.setSelectedModelRuntimeConfig(modelId, null)
    }
    this.toggleOption2('selectedModels', modelId)
  }

  isModelSelected = (model) => {
    const options = this.getOptions()
    return options.selectedModels[model]
  }

  getContextPrice = (model, contexts) => {
    const options = this.getOptions()
    const { inputContext, outputContext } = options
    if (!contexts) {
      return null
    }
    for (let i = 0; i < contexts.length; i++) {
      if (contexts[i].input >= inputContext &&
          (model.image || contexts[i].output >= outputContext)) {
        return contexts[i].price
      }
    }
  }

  getInferenceProviderPrice = (model, providerId) => {
    if (model.providerId) {
      return { input: 0, output: 0 }
    }
    providerId = normalizeProviderId(providerId)
    const providers = providerNodesById(model.inferenceProviders)
    const provider = providers[providerId]
    return this.getContextPrice(model, provider && provider.contexts)
  }

  getPriceFilterCacheKey = (options = this.getOptions()) => stableSignature({
    inputContext: options && options.inputContext,
    outputContext: options && options.outputContext,
    selectedInferenceProviders: options && options.selectedInferenceProviders || {},
    modelsRevision: this.modelsRevision || 0
  })

  getModelPrice = (model, selectedInferenceProviders) => {
    if (!model) {
      return null
    }
    const options = this.getOptions()
    const priceCacheKey = this.getPriceFilterCacheKey(options)
    if (!this.modelPriceCache || this.modelPriceCacheKey !== priceCacheKey) {
      this.modelPriceCacheKey = priceCacheKey
      this.modelPriceCache = {}
    }
    const cacheKey = (model && (model.displayKey || model.id) || '') + ':' + normalizeProviderId(model && model.displayInferenceProviderId)
    if (Object.prototype.hasOwnProperty.call(this.modelPriceCache, cacheKey)) {
      return this.modelPriceCache[cacheKey]
    }
    let price
    if (model.providerId) {
      price = { input: 0, output: 0 }
      this.modelPriceCache[cacheKey] = price
      return price
    }
    if (model.displayInferenceProviderId) {
      price = this.getInferenceProviderPrice(model, model.displayInferenceProviderId)
      this.modelPriceCache[cacheKey] = price || null
      return price
    }
    const inferenceProviderIds = getInferenceProviderIds(model)
    selectedInferenceProviders = selectedInferenceProviders || this.getSelectedInferenceProviderMap(options)
    let candidateProviderIds = inferenceProviderIds.filter(id => {
      return selectedInferenceProviders[id]
    })
    if (!candidateProviderIds.length) {
      candidateProviderIds = inferenceProviderIds
    }
    const prices = candidateProviderIds
      .map(id => this.getInferenceProviderPrice(model, id))
      .filter(price => price)
    prices.sort((x, y) => {
      let cmp = (x.input || 0) - (y.input || 0)
      if (cmp) {
        return cmp
      }
      return (x.output || 0) - (y.output || 0)
    })
    price = prices[0] || null
    this.modelPriceCache[cacheKey] = price
    return price
  }

  getModelRouteIndicator = (model, providerId) => {
    if (this.props.getModelRouteIndicator) {
      return this.props.getModelRouteIndicator(model, providerId)
    }
    return getSubscriptionRouteIndicator(model, providerId, {
      openAICodexOAuth: this.props.openAICodexOAuth || this.state.openAICodexOAuth,
      hosts: this.props.hosts,
      me: this.props.me
    })
  }

  getSelectedModelIds = () => {
    if (this.selectedModelIds) {
      return this.selectedModelIds
    }
    const options = this.getOptions()
    const selected = this.getSelectedModelsList().filter(x => options.selectedModels[x.id])
    return this.selectedModelIds = selected.map(x => x.id)
  }

  getModelsForSelection = () => {
    const selected = this.getSelectedModelsList()
    const result = {}
    for (const model of selected) {
      result[model.id] = true
    }
    return result
  }

  getProviderOptions = (getIds, getNames) => {
    const ids = {}
    const names = {}
    for (const model of this.getModels()) {
      const modelNames = getNames ? getNames(model) : {}
      Object.assign(names, modelNames)
      for (const id of getIds(model)) {
        ids[id] = true
      }
    }
    const options = Object.keys(ids).map(id => createProviderOption(id, this.props.vendors, names)).filter(option => option)
    options.sort((x, y) => {
      let cmp = x.sortOrder - y.sortOrder
      if (cmp) {
        return cmp
      }
      return x.name.localeCompare(y.name)
    })
    return options
  }

  getInferenceProviderIdsForTopLevel = model => {
    if (isCustomModel(model)) {
      return ['custom']
    }
    return getInferenceProviderIds(model)
  }

  getInferenceProviderNamesForTopLevel = model => {
    if (isCustomModel(model)) {
      return { custom: 'Custom' }
    }
    return providerNamesById(model.inferenceProviders)
  }

  getModelProviderOptions = () => {
    if (!this.modelProviderOptions) {
      this.modelProviderOptions = this.getProviderOptions(model => {
        return [getModelProviderId(model)].filter(x => x)
      }, model => {
        const id = getModelProviderId(model)
        return id && model.modelProvider ? { [id]: model.modelProvider } : {}
      })
    }
    return this.modelProviderOptions
  }

  getInferenceProviderOptions = () => {
    if (!this.inferenceProviderOptions) {
      const groups = {}
      const names = {}
      for (const model of this.getModels()) {
        Object.assign(names, this.getInferenceProviderNamesForTopLevel(model))
        for (const providerId of this.getInferenceProviderIdsForTopLevel(model)) {
          const id = normalizeProviderId(providerId)
          const billingProvider = inferenceBillingProviders[id] || {}
          const groupId = normalizeProviderId(billingProvider.id || id)
          if (!groups[groupId]) {
            groups[groupId] = {
              id: groupId,
              providerIds: []
            }
          }
          if (!groups[groupId].providerIds.includes(id)) {
            groups[groupId].providerIds.push(id)
          }
        }
      }
      Object.values(groups).forEach(group => {
        group.providerIds.sort((x, y) => {
          const orderX = getProviderSortOrder(x)
          const orderY = getProviderSortOrder(y)
          if (orderX !== null || orderY !== null) {
            return (orderX ?? 1000) - (orderY ?? 1000)
          }
          return String(x || '').localeCompare(String(y || ''))
        })
      })
      this.inferenceProviderOptions = Object.values(groups).map(group => {
        return createInferenceBillingProviderOption(group.providerIds[0] || group.id, group.providerIds, this.props.vendors, names)
      }).filter(option => option)
      this.inferenceProviderOptions.sort((x, y) => {
        let cmp = x.sortOrder - y.sortOrder
        if (cmp) {
          return cmp
        }
        return x.name.localeCompare(y.name)
      })
    }
    return this.inferenceProviderOptions
  }

  getSelectedInferenceProviderMap = (options = this.getOptions()) => {
    return selectedProviderMap(options.selectedInferenceProviders, this.getInferenceProviderOptions())
  }

  getSelectedModels = () => {
    const ids = this.getSelectedModelIds()
    const result = {}
    for (const id of ids) {
      result[id] = true
    }
    return result
  }

  getSelectedModelsListFiltered = () => {
    const options = this.getOptions()
    const selectedModelsList = this.getSelectedModelsList()
    const cacheKey = this.selectedModelsListCacheKey + ':' + stableSignature({
      fineTunedModel: this.props.fineTunedModel,
      selectedModels: options && options.selectedModels || {},
      selectedModelRuntimeOptions: options && options.selectedModelRuntimeOptions || {}
    })
    if (this.selectedModelsListFiltered && this.selectedModelsListFilteredCacheKey === cacheKey) {
      return this.selectedModelsListFiltered
    }
    this.selectedModelsListFilteredCacheKey = cacheKey
    return this.selectedModelsListFiltered = selectedModelsList.filter(x => {
      let ok = x.id === this.props.fineTunedModel || options.selectedModels[x.id]
      return ok
    }).map(this.applySelectedRuntimeConfig)
  }

  keys = obj => {
    const keys = Object.keys(obj)
    return keys.filter(key => obj[key] !== null)
  }

  values = obj => {
    return Object.values(obj).filter(x => x !== null)
  }

  supportsCheckpoints = model => {
    return model.finetune && model.finetune.inference && model.finetune.inference.checkpoints
  }
  
  getSelectedModelsList = () => {
    const cacheKey = this.getSelectedModelsListCacheKey()
    if (!this.selectedModelsList || this.selectedModelsListCacheKey !== cacheKey) {
      this.selectedModelsListCacheKey = cacheKey
      this.updateSelectedModelsList()
    }
    return this.selectedModelsList
  }

  getSelectedModelsListCacheKey = () => {
    const options = this.getOptions() || {}
    this.getModels()
    return stableSignature({
      providerFilterMode: this.state.providerFilterMode || 'model',
      searchTerm: String(this.state.searchTerm || '').trim().toLowerCase(),
      selectedVendors: options.selectedVendors || {},
      selectedInferenceProviders: options.selectedInferenceProviders || {},
      selectedFinetunes: options.selectedFinetunes || {},
      sizes: options.sizes || {},
      inputContext: options.inputContext,
      outputContext: options.outputContext,
      inputPrice: options.inputPrice,
      baseModels: options.baseModels,
      visionModels: options.visionModels,
      imageGeneration: options.imageGeneration,
      reasoningModels: options.reasoningModels,
      legacyModels: options.legacyModels,
      finetune: options.finetune,
      fineTunedModel: this.props.fineTunedModel,
      priceFilter: this.getPriceFilterCacheKey(options),
      modelsRevision: this.modelsRevision || 0
    })
  }

  updateSelectedModelsList = () => {
    const options = this.getOptions()
    //////console.log("options", options)
    if (!options) return []
    const models = this.getModels()
    ////console.log("options", {options})
    const modelProviders = this.getModelProviderOptions()
    const inferenceProviders = this.getInferenceProviderOptions()
    const providerFilterMode = this.state.providerFilterMode || 'model'
    const selectedInferenceProviders = this.getSelectedInferenceProviderMap(options)
    const allVendors = providerFilterMode !== 'model' || Object.keys(options.selectedVendors).filter(x => {
      return options.selectedVendors[x] && modelProviders.find(y => y.id === x)
    }).length === 0
    const allInferenceProviders = providerFilterMode !== 'inference' || getSelectedProviderCount(selectedInferenceProviders) === 0
    const allSizes =  this.values(options.sizes).length === 0
    const allFinetunes = this.values(options.selectedFinetunes || {}).length === 0
    let searchTerm
    if (this.state.searchTerm) {
      searchTerm = this.state.searchTerm.trim().toLowerCase()
    }
    const selected = models.filter(model => {
      if (model.id === this.props.fineTunedModel) {
        return true
      }
      if (model.deleted) {
        return false
      }
      if (!this.props.vendors) {
        return false
      }
      if (model.providerId) {
        //debugger
      }
      const modelProviderId = getModelProviderId(model)
      const inferenceProviderIds = getInferenceProviderIds(model)
      const vendor = modelProviders.find(x => x.id === modelProviderId) ||
        (modelProviderId ? { id: modelProviderId, name: getProviderName(modelProviderId, this.props.vendors, model.modelProvider ? { [modelProviderId]: model.modelProvider } : {}) } : null)
      if (vendor) {
        let sizeOk = true
        if (!allSizes) {
          sizeOk = options.sizes[model.getSize()]
        }
        const vendorOk = providerFilterMode !== 'model' || allVendors || options.selectedVendors[vendor.id]
        const inferenceProviderOk = providerFilterMode !== 'inference' || allInferenceProviders || providerIntersectsSelection(inferenceProviderIds, selectedInferenceProviders, isCustomModel(model))
        ////console.log({model, sizeOk, vendorOk})
        let checkpointsOk = this.supportsCheckpoints(model) &&  this.getCheckpoints()
        let visionOk = true
        let imageOk = true
        let reasoningOk = true
        let baseOk = true
        let legacyOk = false
        let finetuneOk = true
        let finetunesOk = true
        let priceOk = false
        let contextOk = this.getModelPrice(model, selectedInferenceProviders)
        let checkpointOk = true
        if (searchTerm) {
          const inferenceProviderNames = getProviderNameList(inferenceProviderIds, this.props.vendors, providerNamesById(model.inferenceProviders))
          const searchable = [model.title, model.id, vendor.name].concat(inferenceProviderNames).filter(x => x)
          const ok = searchable.find(value => value.toLowerCase().startsWith(searchTerm))
          if (!ok) return false
        }
        if (contextOk) {
          const { input } = contextOk
          priceOk = !options.inputPrice || input <= options.inputPrice
        }
        if (options.finetune) {
          finetuneOk = model.finetune && !model.isCheckpoint
        }
        if (!checkpointsOk) {
            checkpointOk = !model.isFinetune || !model.isCheckpoint
        }
        if (options.visionModels) {
          visionOk = model.vision
        }
        if (options.imageGeneration) {
          imageOk = model.image
        }
        if (model.isBase) {
          baseOk = options.baseModels
        }
        if (options.reasoningModels) {
          reasoningOk = model.reasoning
        }
        if (options.legacyModels) {
          legacyOk = true
        } else {
          legacyOk = !model.legacy
        }
        if (!allFinetunes) {
          finetunesOk = !model.isFinetune || options.selectedFinetunes[model.rootModel]
        } else {
          finetunesOk = !model.isFinetune
        }
        if (model.providerId) {
          contextOk = true
          priceOk = true
        }
        ////console.log({model,
        //contextOk,  sizeOk,  vendorOk,  visionOk,  baseOk,  legacyOk,  priceOk,  finetunesOk,  finetuneOk,  checkpointOk,  imageOk
        //})
        const result = reasoningOk && contextOk && sizeOk && vendorOk && inferenceProviderOk && visionOk && baseOk && legacyOk && priceOk && finetunesOk && finetuneOk && checkpointOk && imageOk
        ////console.log(model.name, result)
        return result
      }
      return false
    })
    this.selectedModelsList = selected
  }

  isVision = () => {
    return this.getOption('visionModels')
  }

  isImage = () => {
    return this.getOption('imageGeneration')
  }

  toggleImage = () => {
    this.toggleOption('imageGeneration')
  }

  toggleOption = option => {
    let options = this.getOptions()
    if (this.props.singleSelect) {
      options = {
        [option]: true
      }
    } else {
      options[option] = !options[option]
    }
    this.forceUpdate1(this.saveOptionsLater)
  }

  getOption = option => {
    const options = this.getOptions()
    return options[option]
  }

  setOption = (updates) => {
    const options = this.getOptions()
    for (const key in updates) {
      options[key] = updates[key]
    }
    this.forceUpdate1(this.saveOptionsLater)
  }

  toggleOption2 = (option, key) => {
    if (!key) {
      return
    }
    let options = this.getOptions()
    if (!options[option]) {
      options[option] = {}
    }
    if (this.props.singleSelect) {
      options[option] = { [key]: true }
    } else {
      if (options[option][key]) {
        options[option][key] = null
      } else {
        options[option][key] = true
      }
    }
    this.forceUpdate1(this.saveOptionsLater)
  }

  forceUpdate1 = (k) => {
    //console.log("forceUpdate", this.menu && this.menu.open)
    this.invalidateFilterCache()
    this.props.onOptionsChanged(this.state.options)
    if (this.menu && this.menu.open) {
      this.forceUpdate(k)
    } else {
      if (k) k()
    }
  }

  getOption2 = (option, key) => {
    let options = this.getOptions()[option] || {}
    return (options && options[key] !== null && options[key]) || undefined
  }

  toggleVision = () => {
    this.toggleOption('visionModels')
  }

  toggleOpenSource = () => {
    this.toggleOption('openSource')
  }

  isLegacy = () => {
    return this.getOption('legacyModels')
  }

  toggleLegacy = () => {
    this.toggleOption('legacyModels')
  }

  isFinetunable = () => {
    return this.getOption('finetune')
  }

  toggleFinetunable = () => {
    this.toggleOption('finetune')
  }

  toggleCheckpoints = () => {
    this.toggleOption('checkpoints')
  }

  getCheckpoints = () => {
    return this.getOption('checkpoints')
  }

  isFinetune = (model) => {
    return this.getOption2('selectedFinetunes', model)
  }

  toggleFinetune = (model) => {
    this.toggleOption2('selectedFinetunes', model)
  }

  isBase = () => {
    return this.getOption('baseModels')
  }

  toggleBase = () => {
    return this.toggleOption('baseModels')
  }

  isReasoning = () => {
    return this.getOption('reasoningModels')
  }
  
  toggleReasoning = () => {
    return this.toggleOption('reasoningModels')
  }

  isVendorSelected = vendor => {
    return this.getOption2('selectedVendors', vendor.id)
  }

  toggleVendor = vendor => {
    if (this.props.preview) {
      //return
    }
    this.setProviderFilterMode('model')
    this.toggleOption2('selectedVendors', vendor.id)
  }

  isInferenceProviderSelected = provider => {
    if (!provider || !provider.id) {
      return false
    }
    if (this.getOption2('selectedInferenceProviders', provider.id)) {
      return true
    }
    return (provider.providerIds || []).find(id => this.getOption2('selectedInferenceProviders', id))
  }

  toggleInferenceProvider = provider => {
    if (this.props.preview) {
      //return
    }
    this.setProviderFilterMode('inference')
    if (provider.providerIds && provider.providerIds.length) {
      const options = this.getOptions()
      if (!options.selectedInferenceProviders) {
        options.selectedInferenceProviders = {}
      }
      const selected = this.isInferenceProviderSelected(provider)
      const selectedProviderId = normalizeProviderId(provider.id)
      options.selectedInferenceProviders[selectedProviderId] = selected ? null : true
      for (const childProviderId of provider.providerIds) {
        const normalizedChildProviderId = normalizeProviderId(childProviderId)
        if (normalizedChildProviderId !== selectedProviderId) {
          options.selectedInferenceProviders[normalizedChildProviderId] = null
        }
      }
      this.forceUpdate1(this.saveOptionsLater)
      return
    }
    this.toggleOption2('selectedInferenceProviders', provider.id)
  }

  setOutputContext = outputContext => {
    this.setOption({outputContext})
  }
  
  setInputContext = inputContext => {
    this.setOption({inputContext})
  }

  setInputPrice = inputPrice => {
    this.setOption({inputPrice})
  }
  
  getInputPrice= () =>  {
    return this.getOption('inputPrice')
  }

  getInputContext = () => {
    return this.getOption('inputContext')
  }

  getOutputContext = () => {
    return this.getOption('outputContext')
  }

  getModelsSourceCacheKey = () => stableSignature({
    vendors: providerListSignature(this.props.vendors),
    hosts: hostListSignature(this.props.hosts),
    openAICodexOAuth: oauthSignature(this.props.openAICodexOAuth || this.state.openAICodexOAuth)
  })

  getModels = () => {
    const sourceCacheKey = this.getModelsSourceCacheKey()
    if (!this.models || this.modelsSourceCacheKey !== sourceCacheKey) {
      this.modelsSourceCacheKey = sourceCacheKey
      this.modelsRevision = (this.modelsRevision || 0) + 1
      this.modelProviderOptions = null
      this.inferenceProviderOptions = null
      this.invalidateFilterCache()
      this.models = this.props.models(this.isModelSelected, this.selectModel).filter(x => {
        return x.getSize
      }).map(model => withVirtualInferenceProviders(model, {
        openAICodexOAuth: this.props.openAICodexOAuth || this.state.openAICodexOAuth,
        hosts: this.props.hosts,
        me: this.props.me,
        vendors: this.props.vendors
      }))
      this.modelsById = {}
      this.models.forEach(model => {
        this.modelsById[model.id] = model
      })
    }
    return this.models
  }

  onCreateMenu = menu => {
    this.menu = menu
  }

  setProviderFilterMode = providerFilterMode => {
    if (this.state.providerFilterMode === providerFilterMode) {
      return
    }
    this.invalidateFilterCache()
    this.setState({ providerFilterMode }, () => this.props.onOptionsChanged(this.state.options))
  }

  getVendorItemsCacheKey = () => {
    this.getSelectedModelsList()
    const options = this.getOptions() || {}
    return stableSignature({
      providerFilterMode: this.state.providerFilterMode || 'model',
      selectedModelsListCacheKey: this.selectedModelsListCacheKey,
      selectedModels: options.selectedModels || {},
      selectedModelRuntimeOptions: options.selectedModelRuntimeOptions || {},
      selectedInferenceProviders: options.selectedInferenceProviders || {},
      selectedVendors: options.selectedVendors || {},
      vendors: providerListSignature(this.props.vendors),
      searchTerm: String(this.state.searchTerm || '').trim().toLowerCase(),
      preview: this.props.preview,
      vendorOpen: this.props.vendorOpen,
      vendorOpon: this.props.vendorOpon
    })
  }

  showPopup = () => {
    this.menu.showPopup()
  }

  hidePopup = () => {
    this.menu.hidePopup()
  }

  togglePopup = () => {
    this.menu.togglePopup()
  }

  renderVendorItems = () => {
    const vendorItemsCacheKey = this.getVendorItemsCacheKey()
    if (this.vendorItems && this.vendorItemsCacheKey === vendorItemsCacheKey) {
      return this.vendorItems
    }
    const vendors = {}
    const providerFilterMode = this.state.providerFilterMode || 'model'
    let vendorList = providerFilterMode === 'inference' ? this.getInferenceProviderOptions() : this.getModelProviderOptions()
    vendorList = [].concat(vendorList)
    const vendorOptionsById = {}
    const registerVendorOption = option => {
      if (!option || !option.id) {
        return
      }
      vendorOptionsById[option.id] = option
      ;(option.providerIds || []).forEach(id => {
        vendorOptionsById[normalizeProviderId(id)] = option
      })
    }
    vendorList.forEach(registerVendorOption)
    const addModelBackedProviderOption = (id, model, names) => {
      id = normalizeProviderId(id)
      if (!id) {
        return null
      }
      if (vendorOptionsById[id]) {
        return vendorOptionsById[id]
      }
      const option = createModelBackedProviderOption(id, model, this.props.vendors, names)
      if (!option) {
        return null
      }
      vendorList.push(option)
      registerVendorOption(option)
      return option
    }
    const selectedInferenceProviders = this.getSelectedInferenceProviderMap()
    const restrictInferenceProviders = providerFilterMode === 'inference' && getSelectedProviderCount(selectedInferenceProviders) > 0
    for (const model of this.getSelectedModelsList()) {
      if (providerFilterMode === 'inference') {
        const providerNames = providerNamesById(model.inferenceProviders)
        const runtimeProviderIds = isCustomModel(model)
          ? getInferenceProviderIds(model)
          : this.getInferenceProviderIdsForTopLevel(model)
        for (const providerId of runtimeProviderIds) {
          const id = normalizeProviderId(providerId)
          const topLevelProviderId = isCustomModel(model) ? 'custom' : id
          if (restrictInferenceProviders && !selectedInferenceProviders[id] && !selectedInferenceProviders[topLevelProviderId] && !(isCustomModel(model) && selectedInferenceProviders.custom)) {
            continue
          }
          const group = vendorOptionsById[topLevelProviderId] || vendorList.find(vendor => {
            return vendor.id === topLevelProviderId || (vendor.providerIds || []).includes(topLevelProviderId)
          }) || addModelBackedProviderOption(topLevelProviderId, model, topLevelProviderId === 'custom' ? { custom: 'Custom' } : providerNames)
          if (!group) {
            continue
          }
          let arr = vendors[group.id]
          if (!arr) {
            vendors[group.id] = arr = []
          }
          const providerNode = providerNodesById(model.inferenceProviders)[id] || {}
          const providerOption = createProviderOption(id, this.props.vendors, providerNames)
          const customProviderOption = isCustomModel(model)
            ? createProviderOption('custom', this.props.vendors, { custom: 'Custom' })
            : null
          const displayInferenceProviderName = providerNode.name ||
            (normalizeProviderId(model.inferenceProviderId) === id ? model.inferenceProvider : '') ||
            providerNames[id] ||
            providerOption && providerOption.name ||
            getProviderName(id, this.props.vendors, providerNames)
          const displayInferenceProviderIcon = providerOption && providerOption.getIcon
            ? providerOption.getIcon()
            : customProviderOption && customProviderOption.getIcon
              ? customProviderOption.getIcon()
              : null
          const modelTitle = model.title || model.name || model.id
          const titlePrefix = String(displayInferenceProviderName || '').trim()
          const displayTitle = //titlePrefix && !String(modelTitle || '').toLowerCase().startsWith(titlePrefix.toLowerCase() + ' ')
                //? titlePrefix + ' ' + modelTitle
                //: modelTitle
                modelTitle
          arr.push({
            ...model,
            displayKey: model.id + ':' + id,
            displayTitle,
            displayInferenceProviderId: id,
            displayInferenceProviderName,
            displayInferenceProviderIcon
          })
        }
        continue
      }
      const providerId = getModelProviderId(model)
      addModelBackedProviderOption(providerId, model, model.modelProvider ? { [providerId]: model.modelProvider } : {})
      let arr = vendors[providerId]
      if (!arr) {
        vendors[providerId] = arr = []
      }
      if (model.providerId) {
        //debugger
      }
      arr.push(model)
    }
    vendorList.sort((x, y) => {
      const xOrder = x.sortOrder !== undefined ? x.sortOrder : 1000
      const yOrder = y.sortOrder !== undefined ? y.sortOrder : 1000
      let cmp = xOrder - yOrder
      if (cmp) {
        return cmp
      }
      return String(x.name || '').localeCompare(String(y.name || ''))
    })
    let vendorItems = []
    const selectedVendors = this.keys(vendors)
    for (const vendor of vendorList) {
      const models = vendors[vendor.id] || []
      if (vendor.id ===  'hf') {
        //debugger
      }
      //debugger
      vendorItems.push(<ModelVendor
                         preview={this.props.preview}
                         key={vendor.id}
                         configure={this.props.configure}
                         open={this.props.vendorOpon || selectedVendors.length === 1}
                         vendorOpen={this.props.vendorOpen}
                         vendor={vendor}
                         me={this.props.me}
                         models={models}
                         vendors={this.props.vendors}
                         providerFilterMode={providerFilterMode}
                         isInferenceProviderSelected={this.isInferenceProviderSelected}
                         toggleInferenceProvider={this.toggleInferenceProvider}
                         getInferenceProviderPrice={this.getInferenceProviderPrice}
                         getSelectedModelRuntimeConfig={this.getSelectedModelRuntimeConfig}
                         getModelRouteIndicator={this.getModelRouteIndicator}
                         searchTerm={this.state.searchTerm}
                         formatPrice={price => formatPrice(price, 5)}
                         getPrice={this.getModelPrice}/>)
    }
    this.vendorItemsCacheKey = vendorItemsCacheKey
    this.vendorItems = vendorItems
    return vendorItems
  }

  renderDetail() {
    if (!this.props.preview) {
      const vendorItems = this.renderVendorItems()
      return <VendorItems>{vendorItems}</VendorItems>
    }
  }

  render() {
    if (this.props.noSplitView) {
      return this.renderContent()
    }
    return super.render()
  }

  renderContent() {
    const toggleSize = (size) => {
      this.toggleOption2('sizes', size)
    }
    const getSizes = () => this.getOption('sizes')
    const toggleSmall = () => toggleSize('small')
    const toggleMedium = () => toggleSize('medium')
    const toggleLarge = () => toggleSize('large')
    let modelsMenu = (menuActive) => <ModelsMenu
                                       singleSelect={this.props.singleSelect}
                                       renderVendorItems={this.renderVendorItems}
                                       clearOptions={this.clearOptions}
                                       configure={this.props.configure}
                                       placeholder={this.props.placeholder}
                                       getIcon={this.props.getIcon}
                                       className={this.props.className}
                                       onCreate={this.onCreateMenu}
                                       keys={this.keys}
                                       collection={this.props.collection || 'models'}
                                       inline={menuActive}
                                       formatPrice={price => formatPrice(price, 5)}
                                       menuActive={menuActive}
                                       getPrice={this.getModelPrice}
                                       getInferenceProviderPrice={this.getInferenceProviderPrice}
                                       getModelRouteIndicator={this.getModelRouteIndicator}
                                       isVendorSelected={this.isVendorSelected}
                                       toggleVendor={this.toggleVendor}
                                       vendors={this.props.vendors.filter(x => !x.disabled)}
                                       modelProviders={this.getModelProviderOptions().filter(x => !x.disabled)}
                                       inferenceProviders={this.getInferenceProviderOptions().filter(x => !x.disabled)}
                                       isInferenceProviderSelected={this.isInferenceProviderSelected}
                                       toggleInferenceProvider={this.toggleInferenceProvider}
                                       providerFilterMode={this.state.providerFilterMode || 'model'}
                                       setProviderFilterMode={this.setProviderFilterMode}
                                       models={this.getModels()}
                                       selectedModels={this.getSelectedModels()}
                                       modelsForSelection={this.getSelectedModelsList()}
                                       visible={true}
                                       sizes={getSizes()}
                                       toggleSmall={toggleSmall}                 
                                       toggleMedium={toggleMedium}                 
                                       toggleLarge={toggleLarge}
                                       toggleVision={this.toggleVision}
                                       isImage={this.isImage()}
                                       toggleImage={this.toggleImage}
                                       isVision={this.isVision()}
                                       toggleBase={this.toggleBase}
                                       toggleReasoning={this.toggleReasoning}
                                       toggleLegacy={this.toggleLegacy}
                                       inputContext={this.getInputContext()}
                                       outputContext={this.getOutputContext()}
                                       setInputContext={this.setInputContext}
                                       setOutputContext={this.setOutputContext}
                                       inputPrice={this.getInputPrice()}
                                       setInputPrice={this.setInputPrice}
                                       isBase={this.isBase()}
                                       isReasoning={this.isReasoning()}
                                       isLegacy={this.isLegacy()}
                                       toggleFinetune={this.toggleFinetune}
                                       isFinetune={this.isFinetune}
                                       toggleCheckpoints={this.toggleCheckpoints}
                                       checkpoints={this.getCheckpoints()}
                                       toggleFinetunable={this.toggleFinetunable}
                                       isFinetunable={this.isFinetunable()}
                                       preview={this.props.preview}
                                       vendorOnly={this.props.vendorOnly}
                                       unselectable={this.props.unselectable}
                                       topLevel={this.props.topLevel}
                                       noSplitView={this.props.noSplitView}
                                       vendorOpen={this.props.vendorOpen}
                                     >
                                       {this.props.children}
                                     </ModelsMenu>
    return <div className='modelsView'>
             {modelsMenu(this.props.menuActive)}
           </div>
  }
}
